
<div id="app-feedback-sd" class="container d-flex flex-column flex-grow-1 mt-5 pt-4 pb-4 h-100" role="main"
  [attr.aria-label]="('FEEDBACK' | translate)">
  <div class="d-flex justify-content-between align-items-center">
    <app-headline [type]="'h4'" [class]="'text-muted fw-bold m-0 pe-2'"
      [title]="('FEEDBACK' | translate)"></app-headline>
    <div class="d-flex align-items-center">
      <!-- Status Text for Admin/User -->
      <app-headline [type]="'h6'" [class]="'text-muted fw-bold m-0 truncate-text-one-line'"
        [title]="(isAdmin ? 'FEEDBACKADMINMODESTATUSTEXT' : 'FEEDBACKUSERMODESTATUSTEXT') | translate"></app-headline>

      <!-- Admin Mode Button -->
      <ejs-tooltip target=".adminmode-target" [content]="'FEEDBACKADMINMODETOOLTIP' | translate" opensOn="Auto"
        position="TopCenter" [animation]="'Fade'" [windowCollision]="'flip'">
        <app-form-button (click)="onChangeMode()"
          [cssClass]="isAdmin ? 'e-btn e-primary m-1 px-1 adminmode-target' : 'e-btn e-white m-1 px-1 adminmode-target'"
          [icon]="'admin_panel_settings'" [iconPosition]="'right'" [iconClass]="'fs-3'"></app-form-button>
      </ejs-tooltip>

      <!-- User Mode Button -->
      <ejs-tooltip target=".usermode-target" [content]="'FEEDBACKUSERMODETOOLTIP' | translate" opensOn="Auto"
        position="TopCenter" [animation]="'Fade'" [windowCollision]="'flip'">
        <app-form-button (click)="onChangeMode()"
          [cssClass]="isAdmin ? 'e-btn e-white m-1 px-1 usermode-target' : 'e-btn e-primary m-1 px-1 usermode-target'"
          [icon]="'person'" [iconPosition]="'right'" [iconClass]="'fs-3'"></app-form-button>
      </ejs-tooltip>
    </div>
  </div>
  <div class="custom-scrollbar overflow-y-auto mb-3">
    <div class="card mb-3">
      <div class="card-body p-0">
        <div class="card border-0 box-shadow-bottom">
          <div class="card-body text-center p-4">
            <!-- This is needed but removed because of Marcel's presentations -->
          
            <div class="my-3">
              <div
                class="no-content-large-icon bg-lightpurple rounded-circle d-flex justify-content-center align-items-center mx-auto">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  [fontColor]="'text-white'"></app-icon-badge>
              </div>
              <div class="mt-3">
                <app-headline [title]="'Sie haben noch keine Feedbacks erhalten.'" [type]="'h5'"
                  [class]="'card-title'"></app-headline>
              </div>
            </div>

            <div *ngIf="isAdmin" class="feedback-menu-cards d-flex justify-content-center align-items-center mt-5">
              <div class="row g-3 row-cols-1 row-cols-md-3 w-100">
                <div class="col d-flex">
                  <div class="card card-selectable h-100 d-flex flex-column flex-grow-1 cursor-pointer"
                    [class.active]="selectedCard === 'manage'" (click)="setSelectedCard('manage')"
                    (keydown)="handleCardKey($event, 'manage')" tabindex="0">
                    <div class="card-body d-flex flex-column align-items-start flex-grow-1 justify-content-between">
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <div class="icon d-flex align-items-center justify-content-center">
                          <app-icon-badge [style]="'default'" [icon]="'draft_orders'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                        <app-headline [title]="'Alle verwalten'" [type]="'h5'" [class]="'card-title'"></app-headline>
                      </div>
                      <app-content [fontSize]="'fs-normal'" [fontColor]="'text-secondary'">Bestehende Feedbacks erstellen oder verwalten</app-content>
                    </div>
                  </div>
                </div>

                <div class="col d-flex">
                  <div class="card card-selectable h-100 d-flex flex-column flex-grow-1 cursor-pointer"
                    [class.active]="selectedCard === 'drafts'" (click)="setSelectedCard('drafts')"
                    (keydown)="handleCardKey($event, 'drafts')" tabindex="0">
                    <div class="card-body d-flex flex-column align-items-start flex-grow-1 justify-content-between">
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <div class="icon d-flex align-items-center justify-content-center">
                          <app-icon-badge [style]="'default'" [icon]="'draft_orders'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                        <app-headline [title]="'Kollaborativ'" [type]="'h5'" [class]="'card-title'"></app-headline>
                      </div>
                      <app-content [fontSize]="'fs-normal'" [fontColor]="'text-secondary'">Liste freigegebener Feedbacks, die gemeinsam mit einer Gruppe bearbeitet werden</app-content>
                    </div>
                  </div>
                </div>

                <div class="col d-flex">
                  <div class="card card-selectable h-100 d-flex flex-column flex-grow-1 cursor-pointer"
                    [class.active]="selectedCard === 'completed'" (click)="setSelectedCard('completed')"
                    (keydown)="handleCardKey($event, 'completed')" tabindex="0">
                    <div class="card-body d-flex flex-column align-items-start flex-grow-1 justify-content-between">
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <div class="icon d-flex align-items-center justify-content-center">
                          <app-icon-badge [style]="'default'" [icon]="'fact_check'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                        <app-headline [title]="'Abgeschlossen'" [type]="'h5'" [class]="'card-title'"></app-headline>
                      </div>
                      <app-content [fontSize]="'fs-normal'" [fontColor]="'text-secondary'">Liste aller von Benutzern abgeschlossenen Feedbacks</app-content>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <div *ngIf="!isAdmin" class="feedback-menu-cards d-flex justify-content-center align-items-center mt-5">
              <div class="row g-3 row-cols-1 row-cols-md-3 w-100">
                <div class="col d-flex">
                  <div class="card card-selectable h-100 d-flex flex-column flex-grow-1 cursor-pointer"
                    [class.active]="selectedCard === 'mandatory'" (click)="setSelectedCard('mandatory')"
                    (keydown)="handleCardKey($event, 'mandatory')" tabindex="0">
                    <div class="card-body d-flex flex-column align-items-start flex-grow-1 justify-content-between">
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <div class="icon d-flex align-items-center justify-content-center">
                          <app-icon-badge [style]="'default'" [icon]="'release_alert'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                        <app-headline [title]="'Verbindlich'" [type]="'h5'" [class]="'card-title'"></app-headline>
                      </div>
                      <app-content [fontSize]="'fs-normal'" [fontColor]="'text-secondary'">Feedbacks you must complete
                        to stay compliant.</app-content>
                    </div>
                  </div>
                </div>

                <div class="col d-flex">
                  <div class="card card-selectable h-100 d-flex flex-column flex-grow-1 cursor-pointer"
                    [class.active]="selectedCard === 'optional'" (click)="setSelectedCard('optional')"
                    (keydown)="handleCardKey($event, 'optional')" tabindex="0">
                    <div class="card-body d-flex flex-column align-items-start flex-grow-1 justify-content-between">
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <div class="icon d-flex align-items-center justify-content-center">
                          <app-icon-badge [style]="'default'" [icon]="'alt_route'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                        <app-headline [title]="'Optional'" [type]="'h5'" [class]="'card-title'"></app-headline>
                      </div>
                      <app-content [fontSize]="'fs-normal'" [fontColor]="'text-secondary'">Feedback you can choose to
                        take part in.</app-content>
                    </div>
                  </div>
                </div>

                <div class="col d-flex">
                  <div class="card card-selectable h-100 d-flex flex-column flex-grow-1 cursor-pointer"
                    [class.active]="selectedCard === 'completed_user'" (click)="setSelectedCard('completed_user')"
                    (keydown)="handleCardKey($event, 'completed_user')" tabindex="0">
                    <div class="card-body d-flex flex-column align-items-start flex-grow-1 justify-content-between">
                      <div class="d-flex align-items-center gap-2 mb-2">
                        <div class="icon d-flex align-items-center justify-content-center">
                          <app-icon-badge [style]="'default'" [icon]="'fact_check'" [fontSize]="'fs-3'"
                            [fontColor]="'text-muted'"></app-icon-badge>
                        </div>
                        <app-headline [title]="'Completed'" [type]="'h5'" [class]="'card-title'"></app-headline>
                      </div>
                      <app-content [fontSize]="'fs-normal'" [fontColor]="'text-secondary'">Feedback you’ve already
                        completed.</app-content>
                    </div>
                  </div>
                </div>

              </div>
            </div>
            <div *ngIf="isAdmin && selectedCard === 'manage'"
              class="fade-card d-flex align-items-center gap-2 p-2 mt-5 rounded-3 shadow-sm bg-light border flex-wrap">
              <div class="p-1">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-5'"
                  [fontColor]="'text-lightpurple'"></app-icon-badge>
              </div>
              <div class="d-flex flex-column text-start flex-grow-1">
                <app-headline [type]="'h6'" [class]="'fw-bold text-muted'"
                  [title]="'CREATENEWFEEDBACK' | translate"></app-headline>
                <app-content [fontSize]="'fs-default'">{{ 'STARTYOURFIRSTFEEDBACKNOW' | translate }}</app-content>
              </div>
              <div class="d-flex justify-content-end w-only-sm-100">
                <app-form-button [text]="'START' | translate" (click)="onOpenDialog($event,'create-newfeedback')"
                  [cssClass]="'e-primary fw-semibold'"></app-form-button>
              </div>
            </div>
            <div *ngIf="isAdmin && selectedCard === 'drafts'"
              class="fade-card d-flex align-items-center gap-2 p-2 mt-5 rounded-3 shadow-sm bg-light border flex-wrap">
              <div class="p-1">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-5'"
                  [fontColor]="'text-lightpurple'"></app-icon-badge>
              </div>
              <div class="d-flex flex-column text-start flex-grow-1">
                <app-headline [type]="'h6'" [class]="'fw-bold text-muted'"
                  [title]="'CREATENEWCOLABFEEDBACK' | translate"></app-headline>
              </div>
              <div class="d-flex justify-content-end w-only-sm-100">
                <app-form-button [text]="'START' | translate" (click)="onOpenDialog($event,'create-newfeedback')"
                  [cssClass]="'e-primary fw-semibold'"></app-form-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="feedback-main card mb-3">
      <div class="card-body p-card">
        <div class="d-flex align-items-center flex-wrap gap-2 mb-3">
          @if(false) {
            <app-headline [title]="'Titel des gewählten Menüs'" [type]="'h5'" [class]="'text-primary'"></app-headline>
          }
          <div class="search-container ms-auto">
            <app-form-input [type]="'search'" [hasErrorField]="false" [placeholder]="('SEARCHINFEEDBACKS' | translate)" [iconFront]="'search'" [iconBack]="'close'" [iconClickType]="'back'" [fCN]="'search_feedback_string'" [fG]="feedbackForm"></app-form-input>
          </div>
        </div>

        <!-- NEEDED BUT REMOVED FOR PRESENTATION PURPOSE No search result text 
        <div class="py-2">
          <app-headline [title]="('NOSEARCHRESULTS' | translate)" [type]="'h6'"
            [class]="'text-center text-secondary'"></app-headline>
        </div>
        -->
        <div class="pb-2 d-flex align-items-center justify-content-end gap-2">
          <app-headline *ngIf="selectedCard !== 'mandatory' && selectedCard !== 'optional'"
            [title]="'Filtern nach'" [type]="'h6'"
            [class]="'fs-small text-default fw-bold d-none d-sm-flex'"></app-headline>
          <app-form-dropdown *ngIf="selectedCard === 'manage' || selectedCard === 'drafts'" [fG]="feedbackForm"
            [fCN]="'feedbackTileFilter'" [dataSource]="feedbackTileFilter" [placeholder]="'SELECTFILTER' | translate"
            [icon]="'filter_list'" [popupWidth]="'auto'" [cssClass]="'small-filter-dropdown'">
          </app-form-dropdown>
          <app-form-dropdown *ngIf="selectedCard === 'completed' || selectedCard === 'completed_user'"
            [fG]="feedbackForm" [fCN]="'feedbackCompletedFilter'" [dataSource]="feedbackCompletedFilter"
            [placeholder]="'SELECTFILTER' | translate" [icon]="'filter_list'" [popupWidth]="'auto'"
            [cssClass]="'small-filter-dropdown'">
          </app-form-dropdown>
        </div>

        <!-- Tiles container -->
        <div class="feedback-tiles d-flex flex-wrap gap-2 justify-content-start">
          <!-- Admins View -->
          <!-- Tile Card 1 Mandatory-->
          <div *ngIf="isAdmin" class="card mandatory h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-2">
                  <span class="badge bg-lightpurple">Verbindlich</span>
                  <ejs-tooltip target=".repeatingevent-target" [content]="'FEEDBACKREPEATINGTOOLTIP' | translate"
                    opensOn="Auto" position="BottomCenter" [animation]="'Fade'" [windowCollision]="'flip'">
                    <div class="repeatingevent-target stat-link text-muted d-flex align-items-center"
                      (click)="fakeMethod()">
                      <app-icon-badge [style]="'default'" [icon]="'event_repeat'" [fontSize]="'fs-5'"></app-icon-badge>
                    </div>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKEDITSETTINGSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKEDITSETTINGSMENU' | translate) }} - if not running</app-link>
                    </li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKEDITFORMMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKEDITFORMMENU' | translate) }} - if not running</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKPREVIEWFORMMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKPREVIEWFORMMENU' | translate) }} - if already
                        running</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDUPLICATEMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDUPLICATEMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDUPLICATEASCOLABMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDUPLICATEASCOLABMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDELETEMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDELETEMENU' | translate) }} - if not running!!</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="` border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Zufriedenheit mit dem Mitarbeitermanagement'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-2">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Bewerten Sie die Kommunikation, Unterstützung und Führungsqualität Ihres Managements. Ihr Feedback hilft uns, die Zusammenarbeit kontinuierlich zu verbessern.</app-content>
              </div>
              <div class="bottom-container">
                <div class="d-flex align-items-center flex-wrap gap-3">
                  <div class="d-flex align-items-center gap-1">
                    <app-icon-badge [style]="'default'" [icon]="'event_available'" [fontSize]="'fs-6'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                      [fontDecoration]="'fw-bold'">15.06.2024</app-content>
                  </div>
                  <div class="d-flex align-items-center gap-1">
                    <app-icon-badge [style]="'default'" [icon]="'event_busy'" [fontSize]="'fs-6'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                      [fontDecoration]="'fw-bold'">25.06.2024</app-content>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Tile Card 2 Anonym-->
          <div *ngIf="isAdmin" class="card anonym h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-1">
                  <span class="badge bg-grey">Entwurf</span>
                  <span class="badge bg-secondary">Anonym</span>
                  <span class="badge bg-lightpurple">Verbindlich</span>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKEDITSETTINGSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKEDITSETTINGSMENU' | translate) }} - if not running</app-link>
                    </li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKEDITFORMMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKEDITFORMMENU' | translate) }} - if not running</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKPREVIEWFORMMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKPREVIEWFORMMENU' | translate) }} - if already
                        running</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDUPLICATEMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDUPLICATEMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDUPLICATEASCOLABMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDUPLICATEASCOLABMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDELETEMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDELETEMENU' | translate) }} - if not running!!</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="icon-placeholder border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Feedback zur Unternehmenskultur'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-2">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Bewerten Sie Werte, Transparenz und Zusammenarbeit innerhalb unseres Unternehmens.</app-content>
              </div>
              <div class="bottom-container">
                <div class="d-flex align-items-center flex-wrap gap-3">
                  <div class="d-flex align-items-center gap-1">
                    <app-icon-badge [style]="'default'" [icon]="'event_available'" [fontSize]="'fs-6'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                      [fontDecoration]="'fw-bold'">15.06.2024</app-content>
                  </div>
                  <div class="d-flex align-items-center gap-1">
                    <app-icon-badge [style]="'default'" [icon]="'event_busy'" [fontSize]="'fs-6'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                      [fontDecoration]="'fw-bold'">25.06.2024</app-content>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Tile Card 3 Optional-->
          <div *ngIf="isAdmin" class="card h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-1">
                  <span class="badge bg-transparent text-muted border">Optional</span>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKEDITSETTINGSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKEDITSETTINGSMENU' | translate) }} - if not running</app-link>
                    </li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKEDITFORMMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKEDITFORMMENU' | translate) }} - if not running</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKPREVIEWFORMMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKPREVIEWFORMMENU' | translate) }} - if already
                        running</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDUPLICATEMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDUPLICATEMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDUPLICATEASCOLABMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDUPLICATEASCOLABMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDELETEMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDELETEMENU' | translate) }} - if not running!!</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="icon-placeholder border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Onboarding-Prozess bewerten'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-2">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Unterstützen Sie uns dabei, neuen Mitarbeitenden einen optimalen Start zu ermöglichen.</app-content>
              </div>
              <div class="bottom-container">
                <div class="d-flex align-items-center flex-wrap gap-3">
                  <div class="d-flex align-items-center gap-1">
                    <app-icon-badge [style]="'default'" [icon]="'event_available'" [fontSize]="'fs-6'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                      [fontDecoration]="'fw-bold'">15.06.2024</app-content>
                  </div>
                  <div class="d-flex align-items-center gap-1">
                    <app-icon-badge [style]="'default'" [icon]="'event_busy'" [fontSize]="'fs-6'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                      [fontDecoration]="'fw-bold'">25.06.2024</app-content>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Tile Card 4 Anonym-->
          <div *ngIf="isAdmin" class="card anonym h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-1">
                  <span class="badge bg-secondary">Anonym</span>
                  <span class="badge bg-transparent text-muted border">Optional</span>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKEDITSETTINGSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKEDITSETTINGSMENU' | translate) }} - if not running</app-link>
                    </li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKEDITFORMMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKEDITFORMMENU' | translate) }} - if not running</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKPREVIEWFORMMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKPREVIEWFORMMENU' | translate) }} - if already
                        running</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDUPLICATEMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDUPLICATEMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDUPLICATEASCOLABMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDUPLICATEASCOLABMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDELETEMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDELETEMENU' | translate) }} - if not running!!</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="icon-placeholder border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Freiwilliges anonymes Feedback'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-2">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Nutzen Sie diese Möglichkeit, um offen Ihre Meinung zu teilen. Alle Antworten werden anonym behandelt und helfen uns, uns kontinuierlich zu verbessern.</app-content>
              </div>
              <div class="bottom-container">
                <div class="d-flex align-items-center flex-wrap gap-3">
                  <div class="d-flex align-items-center gap-1">
                    <app-icon-badge [style]="'default'" [icon]="'event_available'" [fontSize]="'fs-6'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                      [fontDecoration]="'fw-bold'">15.06.2024</app-content>
                  </div>
                  <div class="d-flex align-items-center gap-1">
                    <app-icon-badge [style]="'default'" [icon]="'event_busy'" [fontSize]="'fs-6'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                    <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-muted'"
                      [fontDecoration]="'fw-bold'">25.06.2024</app-content>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--Users Mandatory View-->
          <!-- Tile Card 1 Anonym-->
          <div *ngIf="!isAdmin && selectedCard === 'mandatory'" class="card mandatory h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-2">
                  <span class="badge bg-lightpurple">Verbindlich</span>
                  <span class="badge bg-secondary">Anonym</span>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="icon-placeholder border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Zufriedenheit mit dem Mitarbeitermanagement'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-3">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.</app-content>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Progress:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">25%</app-content>
                </div>
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Questions:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">15</app-content>
                </div>
              </div>
              <div class="bottom-container d-flex align-items-center justify-content-center">
                <app-form-button [text]="'FEEDBACKSTARTBUTTON' | translate"
                  (click)="routerService.navigateTo('feedback-displaysd')"
                  [cssClass]="'e-lightpurple e-small mt-1 fs-default fw-semibold'"></app-form-button>
              </div>
            </div>
          </div>

          <!-- Tile Card 2 Mandatory-->
          <div *ngIf="!isAdmin && selectedCard === 'mandatory'" class="card mandatory h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-2">
                  <span class="badge bg-lightpurple">Verbindlich</span>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="icon-placeholder border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Zufriedenheit mit dem Mitarbeitermanagement'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-3">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.</app-content>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Progress:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">25%</app-content>
                </div>
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Questions:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">15</app-content>
                </div>
              </div>
              <div class="bottom-container d-flex align-items-center justify-content-center">
                <app-form-button [text]="'FEEDBACKSTARTBUTTON' | translate" (click)="fakeMethod()"
                  [cssClass]="'e-lightpurple e-small mt-1 fs-default fw-semibold'"></app-form-button>
              </div>
            </div>
          </div>

          <!-- Tile Card 3 Incomplete-->
          <div *ngIf="!isAdmin && selectedCard === 'mandatory'" class="card incomplete h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-2">
                  <span class="badge bg-lightpurple">Verbindlich</span>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="icon-placeholder border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Zufriedenheit mit dem Mitarbeitermanagement'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-3">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.</app-content>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Progress:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">25%</app-content>
                </div>
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Questions:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">15</app-content>
                </div>
              </div>
              <div class="bottom-container d-flex align-items-center justify-content-center">
                <app-form-button [text]="'FEEDBACKCONTINUEBUTTON' | translate"
                  (click)="routerService.navigateTo('feedback-displaysd')"
                  [cssClass]="'e-warning e-small mt-1 fs-default fw-semibold'"></app-form-button>
              </div>
            </div>
          </div>

          <!--Users Optional View-->
          <!-- Tile Card 1 Anonym-->
          <div *ngIf="!isAdmin && selectedCard === 'optional'" class="card h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-2">
                  <span class="badge bg-transparent text-muted border">Optional</span>
                  <span class="badge bg-secondary">Anonym</span>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="icon-placeholder border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Zufriedenheit mit dem Mitarbeitermanagement'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-3">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.</app-content>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Progress:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">25%</app-content>
                </div>
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Questions:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">15</app-content>
                </div>
              </div>
              <div class="bottom-container d-flex align-items-center justify-content-center">
                <app-form-button [text]="'FEEDBACKSTARTBUTTON' | translate"
                  (click)="routerService.navigateTo('feedback-displaysd')"
                  [cssClass]="'e-lightpurple e-small mt-1 fs-default fw-semibold'"></app-form-button>
              </div>
            </div>
          </div>

          <!-- Tile Card 2 Incomplete-->
          <div *ngIf="!isAdmin && selectedCard === 'optional'" class="card incomplete h-100 d-flex flex-column">
            <div class="card-body flex-grow-1 p-card pt-1">
              <div class="heading-menu-container d-flex justify-content-between align-items-center">
                <div class="d-flex flex-wrap align-items-center gap-2">
                  <span class="badge bg-transparent text-muted border">Optional</span>
                </div>
                <div class="dropdown">
                  <div data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <app-icon-badge [style]="'notification'" [icon]="'more_vert'"></app-icon-badge>
                  </div>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKINFOMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
              <div class="title-container d-flex align-items-center my-2">
                <ng-container *ngIf="imageSrc; else noImage">
                  <img [src]="imageSrc" alt="icon" class="card-img me-2" appNgSrcImageError>
                </ng-container>
                <ng-template #noImage>
                  <div class="icon-placeholder border me-2">
                    <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                      [fontColor]="'text-muted'"></app-icon-badge>
                  </div>
                </ng-template>
                <app-headline [title]="'Zufriedenheit mit dem Mitarbeitermanagement'" [type]="'h6'"
                  [class]="'fw-bold truncate-text-three-lines'"></app-headline>
              </div>
              <!-- Description -->
              <div class="description-container mb-3">
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'"
                  [truncateLines]="4">Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.</app-content>
              </div>
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Progress:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">25%</app-content>
                </div>
                <div class="d-flex align-items-center gap-1">
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">Questions:</app-content>
                  <app-content [fontSize]="'fs-verysmall'" [fontColor]="'text-primary'"
                    [fontDecoration]="'fw-bold'">15</app-content>
                </div>
              </div>
              <div class="bottom-container d-flex align-items-center justify-content-center">
                <app-form-button [text]="'FEEDBACKCONTINUEBUTTON' | translate"
                  (click)="routerService.navigateTo('feedback-displaysd')"
                  [cssClass]="'e-warning e-small mt-1 fs-default fw-semibold'"></app-form-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Admin: Users Completed list card -->
        <div *ngIf="isAdmin && selectedCard === 'completed'" class="user-card-container mt-2">
          <div class="d-flex align-items-center gap-2 my-2">
            <app-form-button [text]="'BACK' | translate" (click)="fakeMethod()" [icon]="'chevron_left'"
              [iconPosition]="'left'" [cssClass]="'e-outline e-small fw-semibold align-middle'"
              [iconClass]="'fs-5'"></app-form-button>
            <h5 class="feedback-selected text-primary truncate-text-two-lines m-0">Selected Feedback Name Comes Here
            </h5>

          </div>
          <div *ngIf="isAdmin && selectedCard === 'completed'"
            class="d-flex align-items-center justify-content-end gap-2 py-2">
            <app-form-dropdown [fG]="feedbackForm" [fCN]="'feedbackByUserFilter'" [dataSource]="feedbackByUserFilter"
              [placeholder]="'SELECTFILTER' | translate" [icon]="'filter_list'" [popupWidth]="'auto'"
              [cssClass]="'small-filter-dropdown'">
            </app-form-dropdown>
            <app-form-dropdown [fG]="feedbackForm" [fCN]="'feedbackCompletedFilter'"
              [dataSource]="feedbackCompletedFilter" [placeholder]="'SELECTFILTER' | translate" [icon]="'filter_list'"
              [popupWidth]="'auto'" [cssClass]="'small-filter-dropdown'">
            </app-form-dropdown>
          </div>
          <!-- Mandatory card -->
          <div class="card mandatory p-0 mb-3">
            <div class="card-body d-flex align-items-center justify-content-between gap-2">

              <div class="fixed-width-name d-flex align-items-center gap-2">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  class="feedback-icon"></app-icon-badge>
                <div class="flex-grow-1">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'"
                    [truncateLines]="2">Carsten Jobmann</app-content>
                </div>
                <div class="vr"></div>
              </div>

              <div class="details-container align-items-center gap-2 flex-grow-1 lh-1">
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">12</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="type-public">Public</app-content><!-- if a public feedback add the class 'type-public', if anonym, add the class 'type-anonym'-->
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="feedback-priority">Verbindlich</app-content>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <div class="mobile-details-container">
                  <ejs-tooltip target=".info-icon" opensOn="Click" position="BottomCenter" [animation]="'Fade'"
                    [windowCollision]="'true'">
                    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'"
                      [class]="'info-icon cursor-pointer'"></app-icon-badge>
                    <ng-template #content>
                      <div class="width-max-content">
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">12</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Public</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Verbindlich</app-content>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <span class="mts-icon fs-4">more_horiz</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKSHOWSTATISTICSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWSTATISTICSMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDELETEUSERFEEDBACK' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDELETEUSERFEEDBACK' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Mandatory && Anonym card -->
          <div class="card mandatory p-0 mb-3">
            <div class="card-body d-flex align-items-center justify-content-between gap-2">

              <div class="fixed-width-name d-flex align-items-center gap-2">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  class="feedback-icon"></app-icon-badge>
                <div class="flex-grow-1">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'"
                    [truncateLines]="2">Carsten Jobmann</app-content>
                </div>
                <div class="vr"></div>
              </div>

              <div class="details-container align-items-center gap-2 flex-grow-1 lh-1">
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">12</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="type-anonym">Anonym</app-content><!-- if a public feedback add the class 'type-public', if anonym, add the class 'type-anonym'-->
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="feedback-priority">Verbindlich</app-content>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <div class="mobile-details-container">
                  <ejs-tooltip target=".info-icon" opensOn="Click" position="BottomCenter" [animation]="'Fade'"
                    [windowCollision]="'true'">
                    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'"
                      [class]="'info-icon cursor-pointer'"></app-icon-badge>
                    <ng-template #content>
                      <div class="width-max-content">
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">12</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Anonym</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Verbindlich</app-content>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <span class="mts-icon fs-4">more_horiz</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKSHOWSTATISTICSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWSTATISTICSMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDELETEUSERFEEDBACK' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDELETEUSERFEEDBACK' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Anonym && Optional card -->
          <div class="card anonym p-0 mb-3">
            <div class="card-body d-flex align-items-center justify-content-between gap-2">

              <div class="fixed-width-name d-flex align-items-center gap-2">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  class="feedback-icon"></app-icon-badge>
                <div class="flex-grow-1">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'"
                    [truncateLines]="2">Carsten Jobmann</app-content>
                </div>
                <div class="vr"></div>
              </div>

              <div class="details-container align-items-center gap-2 flex-grow-1 lh-1">
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">12</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="type-anonym">Anonym</app-content><!-- if a public feedback add the class 'type-public', if anonym, add the class 'type-anonym'-->
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="feedback-priority">Optional</app-content>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <div class="mobile-details-container">
                  <ejs-tooltip target=".info-icon" opensOn="Click" position="BottomCenter" [animation]="'Fade'"
                    [windowCollision]="'flip'">
                    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'"
                      [class]="'info-icon cursor-pointer'"></app-icon-badge>
                    <ng-template #content>
                      <div class="width-max-content">
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">12</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Anonym</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Optional</app-content>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <span class="mts-icon fs-4">more_horiz</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKSHOWSTATISTICSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWSTATISTICSMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDELETEUSERFEEDBACK' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDELETEUSERFEEDBACK' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Optional card -->
          <div class="card p-0 mb-3">
            <div class="card-body d-flex align-items-center justify-content-between gap-2">

              <div class="fixed-width-name d-flex align-items-center gap-2">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  class="feedback-icon"></app-icon-badge>
                <div class="flex-grow-1">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'"
                    [truncateLines]="2">Carsten Jobmann</app-content>
                </div>
                <div class="vr"></div>
              </div>

              <div class="details-container align-items-center gap-2 flex-grow-1 lh-1">
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">12</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="type-public">Public</app-content><!-- if a public feedback add the class 'type-public', if anonym, add the class 'type-anonym'-->
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="feedback-priority">Optional</app-content>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <div class="mobile-details-container">
                  <ejs-tooltip target=".info-icon" opensOn="Click" position="BottomCenter" [animation]="'Fade'"
                    [windowCollision]="'true'">
                    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'"
                      [class]="'info-icon cursor-pointer'"></app-icon-badge>
                    <ng-template #content>
                      <div class="width-max-content">
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">12</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Public</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Optional</app-content>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <span class="mts-icon fs-4">more_horiz</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKSHOWSTATISTICSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWSTATISTICSMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKDELETEUSERFEEDBACK' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKDELETEUSERFEEDBACK' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- User: Completed list card -->
        <div *ngIf="!isAdmin && selectedCard === 'completed_user'" class="user-card-container mt-2">
          <!-- Mandatory card -->
          <div class="card mandatory p-0 mb-3">
            <div class="card-body d-flex align-items-center justify-content-between gap-2">

              <div class="fixed-width-name d-flex align-items-center gap-2">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  class="feedback-icon"></app-icon-badge>
                <div class="flex-grow-1">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'"
                    [truncateLines]="2">Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.</app-content>
                </div>
                <div class="vr"></div>
              </div>

              <div class="details-container align-items-center gap-2 flex-grow-1 lh-1">
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">12</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Progress:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">50%</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="type-public">Public</app-content><!-- if a public feedback add the class 'type-public', if anonym, add the class 'type-anonym'-->
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="feedback-priority">Verbindlich</app-content>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <div class="mobile-details-container">
                  <ejs-tooltip target=".info-icon" opensOn="Click" position="BottomCenter" [animation]="'Fade'"
                    [windowCollision]="'flip'">
                    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'"
                      [class]="'info-icon cursor-pointer'"></app-icon-badge>
                    <ng-template #content>
                      <div class="width-max-content">
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">12</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Progress:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">50%</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Public</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Verbindlich</app-content>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <span class="mts-icon fs-4">more_horiz</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKSHOWINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWINFOMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKSHOWSTATISTICSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWSTATISTICSMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Mandatory & Anonym card -->
          <div class="card mandatory p-0 mb-3">
            <div class="card-body d-flex align-items-center justify-content-between gap-2">

              <div class="fixed-width-name d-flex align-items-center gap-2">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  class="feedback-icon"></app-icon-badge>
                <div class="flex-grow-1">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'"
                    [truncateLines]="2">Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.</app-content>
                </div>
                <div class="vr"></div>
              </div>

              <div class="details-container align-items-center gap-2 flex-grow-1 lh-1">
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">12</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Progress:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">50%</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="type-anonym">Anonym</app-content><!-- if a public feedback add the class 'type-public', if anonym, add the class 'type-anonym'-->
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="feedback-priority">Verbindlich</app-content>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <div class="mobile-details-container">
                  <ejs-tooltip target=".info-icon" opensOn="Click" position="BottomCenter" [animation]="'Fade'"
                    [windowCollision]="'flip'">
                    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'"
                      [class]="'info-icon cursor-pointer'"></app-icon-badge>
                    <ng-template #content>
                      <div class="width-max-content">
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">12</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Progress:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">50%</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Anonym</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Verbindlich</app-content>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <span class="mts-icon fs-4">more_horiz</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKSHOWINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWINFOMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKSHOWSTATISTICSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWSTATISTICSMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Anonym && Optional card -->
          <div class="card anonym p-0 mb-3">
            <div class="card-body d-flex align-items-center justify-content-between gap-2">

              <div class="fixed-width-name d-flex align-items-center gap-2">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  class="feedback-icon"></app-icon-badge>
                <div class="flex-grow-1">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'"
                    [truncateLines]="2">Evaluate management efficiency</app-content>
                </div>
                <div class="vr"></div>
              </div>

              <div class="details-container align-items-center gap-2 flex-grow-1 lh-1">
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">12</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Progress:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">50%</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="type-anonym">Anonym</app-content><!-- if a public feedback add the class 'type-public', if anonym, add the class 'type-anonym'-->
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="feedback-priority">Optional</app-content>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <div class="mobile-details-container">
                  <ejs-tooltip target=".info-icon" opensOn="Click" position="BottomCenter" [animation]="'Fade'"
                    [windowCollision]="'flip'">
                    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'"
                      [class]="'info-icon cursor-pointer'"></app-icon-badge>
                    <ng-template #content>
                      <div class="width-max-content">
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">12</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Progress:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">50%</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Anonym</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Optional</app-content>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <span class="mts-icon fs-4">more_horiz</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKSHOWINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWINFOMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKSHOWSTATISTICSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWSTATISTICSMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!-- Optional -->
          <div class="card p-0 mb-3">
            <div class="card-body d-flex align-items-center justify-content-between gap-2">
              <div class="fixed-width-name d-flex align-items-center gap-2">
                <app-icon-badge [style]="'default'" [icon]="'cycle'" [fontSize]="'fs-3'"
                  class="feedback-icon"></app-icon-badge>
                <div class="flex-grow-1">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'"
                    [truncateLines]="2">Evaluate management efficiency</app-content>
                </div>
                <div class="vr"></div>
              </div>

              <div class="details-container align-items-center gap-2 flex-grow-1 lh-1">
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">12</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Progress:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">50%</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                    [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="type-public">Public</app-content><!-- if a public feedback add the class 'type-public', if anonym, add the class 'type-anonym'-->
                </div>
                <div class="vr"></div>
                <div class="detail-item d-flex flex-column">
                  <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                  <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'"
                    class="feedback-priority">Optional</app-content>
                </div>
              </div>

              <div class="d-flex align-items-center gap-2">
                <div class="mobile-details-container">
                  <ejs-tooltip target=".info-icon" opensOn="Click" position="BottomCenter" [animation]="'Fade'"
                    [windowCollision]="'flip'">
                    <app-icon-badge [style]="'default'" [icon]="'info'" [fontSize]="'fs-4'"
                      [class]="'info-icon cursor-pointer'"></app-icon-badge>
                    <ng-template #content>
                      <div class="width-max-content">
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Questions:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">12</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Progress:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">50%</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Completed:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                            [fontDecoration]="'fw-bold'">13.07.2025</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Type:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Public</app-content>
                        </div>
                        <div class="my-1 d-flex gap-1">
                          <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">Priority:</app-content>
                          <app-content [fontSize]="'fs-small'" [fontDecoration]="'fw-bold'">Optional</app-content>
                        </div>
                      </div>
                    </ng-template>
                  </ejs-tooltip>
                </div>
                <div class="dropdown">
                  <button class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown" aria-expanded="false"
                    [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                    <span class="mts-icon fs-4">more_horiz</span>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end">
                    <li><app-link (click)="openPanel()" [title]="('FEEDBACKSHOWINFOMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWINFOMENU' | translate) }}</app-link></li>
                    <li><app-link (click)="fakeMethod()" [title]="('FEEDBACKSHOWSTATISTICSMENU' | translate)"
                        [style]="'dropdown'">{{ ('FEEDBACKSHOWSTATISTICSMENU' | translate) }}</app-link></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Sidebar container (shown only on screens ≥1500px) -->
  <div class="right-panel card p-3" [class.open]="isPanelOpen">
    <div class="d-flex justify-content-between align-items-center py-2">
      <app-headline [title]="('FEEDBACKSIDEPANELINFOTITLE' | translate)" [type]="'h5'"></app-headline>
      <app-form-button [style]="'btn'" (click)="closePanel()" [cssClass]="'btn-close'"></app-form-button>
    </div>
    <div class="my-3 border-top border-bottom">
      <div class="container-fluid py-2">
        <div class="row justify-content-center">
          <div class="editing-tools col text-center" (click)="fakeMethod()">
            <app-icon-badge [style]="'default'" [icon]="'edit'" [fontSize]="'fs-3'"
              [fontColor]="'text-muted'"></app-icon-badge>
            <div class="mt-1">
              <app-content [fontSize]="'fs-normal'" [fontColor]="'text-muted'">{{'EDIT' | translate}}</app-content>
            </div>
          </div>
          <div class="editing-tools col text-center" (click)="fakeMethod()">
            <app-icon-badge [style]="'default'" [icon]="'content_copy'" [fontSize]="'fs-3'"
              [fontColor]="'text-muted'"></app-icon-badge>
            <div class="mt-1">
              <app-content [fontSize]="'fs-normal'" [fontColor]="'text-muted'">{{'DUPLICATE' | translate}}</app-content>
            </div>
          </div>
          <div class="editing-tools col text-center" (click)="fakeMethod()">
            <app-icon-badge [style]="'default'" [icon]="'delete'" [fontSize]="'fs-3'"
              [fontColor]="'text-muted'"></app-icon-badge>
            <div class="mt-1">
              <app-content [fontSize]="'fs-normal'" [fontColor]="'text-muted'">{{'DELETE' | translate}}</app-content>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="custom-scrollbar overflow-y-auto mb-3">
      <div class="d-flex flex-column">
        <div class="d-flex flex-column border-bottom pb-2">
          <app-headline [title]="'Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.'"
            [type]="'h6'" [class]="'text-primary fw-bold fs-default'"></app-headline>
          <div class="mt-2">
            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'" [class]="'d-block'">Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.</app-content>
          </div>
          <div class="d-flex justify-content-end align-items-center">
            <app-form-button [text]="'SHOWATTACHMENTS' | translate" (click)="true"
              [cssClass]="'e-btn e-flat fw-bold fs-small text-muted p-1'" [icon]="'attach_file'" [iconPosition]="'left'"
              [iconClass]="'fs-5'" [hideTextOnMobile]="false"></app-form-button>
          </div>
        </div>
        <div class="d-flex flex-column py-3 border-bottom lh-1">
          <div class="mb-1">
            <app-headline [title]="('PUBLICLINKCOPYLABEL' | translate)" [type]="'h6'"
              [class]="'fw-bold text-muted'"></app-headline>
          </div>
          <app-form-input [fCN]="'feedback_external_link'" [fG]="feedbackForm" [iconBack]="'content_copy'"
            [iconClickType]="'back'" [hasErrorField]="false"></app-form-input>
        </div>
        <div class="d-flex flex-column py-3 border-bottom lh-1">
          <div class="mb-1">
            <app-headline [title]="('POSTEDBY' | translate)" [type]="'h6'"
              [class]="'fw-bold text-muted'"></app-headline>
          </div>
          <app-content [fontSize]="'fs-default'" [fontDecoration]="'fw-bold'" [fontColor]="'text-primary'">Clare
            Doe</app-content>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">23.05.2024 13:08:03</app-content>
        </div>
        <div class="d-flex flex-column py-3 border-bottom lh-1">
          <div class="mb-1">
            <app-headline [title]="('PUBLISHEDDATE' | translate)" [type]="'h6'"
              [class]="'fw-bold text-muted'"></app-headline>
          </div>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">23.06.2024 13:08:03</app-content>
        </div>
        <div class="d-flex flex-column py-3 border-bottom lh-1">
          <div class="mb-1">
            <app-headline [title]="('EXPIRATIONDATE' | translate)" [type]="'h6'"
              [class]="'fw-bold text-muted'"></app-headline>
          </div>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'">23.05.2024
            13:08:03</app-content>
          <app-content [fontSize]="'fs-small'" [fontColor]="'text-danger'" [fontDecoration]="'fw-bold'">Repeating:
            Weekly</app-content>
        </div>

        <div class="py-3 border-bottom">
          <div class="mb-2">
            <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'" [fontDecoration]="'fw-bold'">23 {{
              ('PARTICIPANTS' | translate) }}</app-content>
          </div>
          <div class="participants-container d-flex flex-column mb-2">
            <div class="custom-scrollbar overflow-y-auto">
              <div class="d-flex flex-column gap-2">
                <!--Name Entries-->
                <!--Not highlighted-->
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <div class="e-avatar e-avatar-circle e-avatar-xsmall">
                      <img src="https://ej2.syncfusion.com/demos/src/grid/images/2.png" alt="profile_pic" width="40"
                        height="40" appNgSrcImageError />
                    </div>
                    <app-content [fontSize]="'fs-default'">Carsten Jobman</app-content>
                  </div>
                  <app-content [fontSize]="'fs-default'">5/<b>10</b></app-content>
                </div>
                <!--Not highlighted-->
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center gap-2">
                    <div class="e-avatar e-avatar-circle e-avatar-xsmall">
                      <img src="https://ej2.syncfusion.com/demos/src/grid/images/2.png" alt="profile_pic" width="40"
                        height="40" appNgSrcImageError />
                    </div>
                    <app-content [fontSize]="'fs-default'">Carsten Jobman</app-content>
                  </div>
                  <app-content [fontSize]="'fs-default'">5/<b>10</b></app-content>
                </div>

                <!-- (Highlighted) -->
                <div class="d-flex align-items-center justify-content-between highlighted">
                  <div class="d-flex align-items-center gap-2">
                    <div class="e-avatar e-avatar-circle e-avatar-xsmall">
                      <img src="https://ej2.syncfusion.com/demos/src/grid/images/2.png" alt="profile_pic" width="40"
                        height="40" appNgSrcImageError />
                    </div>
                    <app-content [fontSize]="'fs-default'">Carsten Jobman</app-content>
                  </div>
                  <app-content [fontSize]="'fs-default'">10/<b>10</b></app-content>
                </div>

              </div>
            </div>
          </div>
          <div class="d-flex flex-column align-item-start gap-1">
            <div class="d-flex align-items-center gap-1 cursor-pointer" (click)="fakeMethod()">
              <app-icon-badge [style]="'default'" [icon]="'notifications_active'" [fontSize]="'fs-5'"
                [fontColor]="'text-muted'"></app-icon-badge>
              <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">{{'SENDREMINDER' |
                translate}}</app-content>
              <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">(23.05.2025)</app-content>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="dialogs">
    <!-- Dialog Create New Feedback -->
    <ejs-dialog target=".dialogs" class="steps-dialog" [visible]='visible'
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'60%'" [height]="'60vh'" [zIndex]="999" [showCloseIcon]="false">
      <ng-template #header class="p-1">
        <app-step-header [steps]="steps" [(activeStep)]="activeStep"></app-step-header>
      </ng-template>
      <ng-template #content>
        <div class="d-flex h-100">
          <!-- Left Column -->
          <div class="col-md-4 col-12 d-none d-md-flex flex-column left-container h-100 p-3">
            <div class="text-center mb-4 pt-m">
              <app-headline [title]="'FEEDBACKCREATENEWTITLE' | translate" [type]="'h5'"></app-headline>
            </div>
            <app-step-content [steps]="steps" [(activeStep)]="activeStep"></app-step-content>
            <div class="save-button-container text-center mt-3 d-none d-md-block">
              <app-form-button [text]="'CREATEFEEDBACK' | translate" [disabled]="feedbackForm.invalid"
                (click)="onOpenDialog($event,'start-feedbackcomposer')"
                [cssClass]="'e-primary w-100'"></app-form-button>
            </div>
          </div>

          <!-- Right Column -->
          <div class="col-md-8 col-12 d-flex flex-column flex-grow-1 right-container h-100 overflow-y-auto p-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
              <div class="d-flex align-items-center">
                <app-headline [title]="steps[activeStep]" [type]="'h5'"></app-headline>
                <app-headline *ngIf="activeStep === 2 || activeStep === 3 || activeStep === 6 || activeStep === 7"
                  [title]="'('+('OPTIONALLABEL' | translate) +')'" [type]="'h6'"
                  [class]="'text-success ms-1'"></app-headline>
                <div class="ms-2">
                  <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKCREATENEWHELP' | translate)"
                    [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'"
                    [opensOn]="'Click'"></app-tooltip>
                </div>
              </div>
              <app-form-button [style]="'btn'" (click)="closeNewFeedback()" [cssClass]="'btn-close'"></app-form-button>
            </div>

            <div class="custom-scrollbar overflow-y-auto">
              <form class="p-1 d-flex flex-column h-100">
                <ng-container [ngSwitch]="activeStep">

                  <ng-container *ngSwitchCase="0">
                    <app-form-label [label]="'FEEDBACKTITLELABEL' | translate" [maxChars]="60"
                      [currentChars]="feedbackForm.controls['feedback_title'].value.length"></app-form-label>
                    <app-form-input [placeholder]="('FEEDBACKTITLEPLACEHOLDER' | translate)"
                      [label]="('FEEDBACKTITLEPLACEHOLDER' | translate)"
                      [errorText]="('FEEDBACKTITLETITLEREQUIRED' | translate)" [fCN]="'feedback_title'"
                      [fG]="feedbackForm" [maxChars]="60"></app-form-input>
                    <app-form-label [label]="'FEEDBACKDESCRIPTIONLABEL' | translate"></app-form-label>
                    <app-form-textarea [placeholder]="('FEEDBACKDESCRIPTIONPLACEHOLDER' | translate)"
                      [fCN]="'feedback_question_description'" [fG]="feedbackForm" [richText]="true" [maxChars]="500"
                      [class]="'emojiSmall'"></app-form-textarea>
                  </ng-container>

                  <ng-container *ngSwitchCase="1">
                    <!--Mandatory Feedback-->
                    <app-form-label [label]="'FEEDBACKCREATEASMANDATORYLABEL' | translate"
                      [class]="'text-lightpurple'"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-12">
                        <!--Users are required to participate in the feedback. They cannot skip it.-->
                        <app-form-radio [fG]="feedbackForm" [fCN]="'feedback_type'" [value]="'mandatory'"
                          [placeholder]="'FEEDBACKISMANDATORYLABEL' | translate"
                          [cssClass]="'e-normal'"></app-form-radio>
                      </div>
                    </div>
                    <!--Optional Feedback -->
                    <app-form-label [label]="'FEEDBACKCREATEASOPTIONALLABEL' | translate"
                      [class]="'text-muted'"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-12">
                        <!-- Participation in the feedback is voluntary. Users may choose to skip it. -->
                        <app-form-radio [fG]="feedbackForm" [fCN]="'feedback_type'" [value]="'optional'"
                          [placeholder]="'FEEDBACKISOPTIONALLABEL' | translate"
                          [cssClass]="'e-normal'"></app-form-radio>
                      </div>
                    </div>

                    <!--Anonymity Settings -->
                    <app-form-label [label]="'FEEDBACKWILLBEANONYMLABEL' | translate"
                      [class]="'text-muted'"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-12">
                        <!--No personal information will be collected. Feedback cannot be traced back to the user.-->
                        <app-form-checkbox [fCN]="'anonym_feedback'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                          [labelPosition]="'After'" [label]="'FEEDBACKWILLNOTSAVEUSERINFOTEXT'"></app-form-checkbox>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="2">
                    <app-form-user-group-mail [allowEmails]="true" [allowPush]="true" [(user)]="participantsUserIDs"
                      [(groups)]="participantsGroupIDs" (mailsChange)="participantsMails = $event" [can]="''"
                      (pushUserIDsChange)="pushUserIDs = $event"
                      (pushGroupIDsChange)="pushGroupIDs = $event"></app-form-user-group-mail>
                  </ng-container>

                  <ng-container *ngSwitchCase="3">
                    Single upload image
                  </ng-container>

                  <ng-container *ngSwitchCase="4">
                    Attach any file
                  </ng-container>

                  <ng-container *ngSwitchCase="5">
                    REMOVED STEP!!!!!
                  </ng-container>

                  <ng-container *ngSwitchCase="6">
                    <div class="card p-card mb-3">
                      <app-form-label [label]="'FEEDBACKSTARTDATELABEL' | translate"></app-form-label>
                      <div class="row mb-3">
                        <div class="col-md-6">
                          <app-form-date-time [fG]="feedbackForm" [fCN]="'on_date_time_start'"
                            [placeholder]="'FEEDBACKSTARTDATEPLACEHOLDER' | translate"></app-form-date-time>
                        </div>
                      </div>
                      <app-form-label [label]="'FEEDBACKINVITATIONMESSAGELABEL' | translate"></app-form-label>
                      <div class="row">
                        <div class="col-12">
                          <app-form-textarea [placeholder]="('FEEDBACKINVITATIONMESSAGEPLACEHOLDER' | translate)"
                            [fCN]="'invitation_message'" [fG]="feedbackForm" [rows]="4"></app-form-textarea>
                        </div>
                      </div>
                    </div>

                    <div class="card p-card mb-3">
                      <app-form-label [label]="'FEEDBACKREPEATOPTIONLABEL' | translate"></app-form-label>
                      <div class="mb-3">
                        <div class="row">
                          <div class="col-md-6">
                            <app-form-dropdown [fG]="feedbackForm" [fCN]="'repeatOptions'" [dataSource]="repeatOptions"
                              [placeholder]="'SELECT' | translate"></app-form-dropdown>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-12">
                            <!--The feedback is only available once and disappears after submission (or an optional deadline).-->
                            <app-form-label *ngIf="feedbackForm.get('repeatOptions')?.value === 'onceandexpire'"
                              [type]="'content'" [class]="'text-muted fs-small'"
                              [label]="('FEEDBACKAVAILABLEONCEDESCRIPTION' | translate)"></app-form-label>
                            <!--A new feedback is created every day. You can set an optional deadline for the users. The feedback will disappear after each user completes it.-->
                            <app-form-label *ngIf="feedbackForm.get('repeatOptions')?.value === 'daily'"
                              [type]="'content'" [class]="'text-muted fs-small'"
                              [label]="('FEEDBACKREPEATDAILYDESCRIPTION' | translate)"></app-form-label>
                            <!--A new feedback is created every week. You can set an optional deadline for the users. The feedback will disappear after each user completes it.-->
                            <app-form-label *ngIf="feedbackForm.get('repeatOptions')?.value === 'weekly'"
                              [type]="'content'" [class]="'text-muted fs-small'"
                              [label]="('FEEDBACKREPEATWEEKLYDESCRIPTION' | translate)"></app-form-label>
                            <!--A new feedback is created every month. You can set an optional deadline for the users. The feedback will disappear after each user completes it.-->
                            <app-form-label *ngIf="feedbackForm.get('repeatOptions')?.value === 'monthly'"
                              [type]="'content'" [class]="'text-muted fs-small'"
                              [label]="('FEEDBACKREPEATMONTHLYDESCRIPTION' | translate)"></app-form-label>
                            <!--A new feedback is created every year. You can set an optional deadline for the users. The feedback will disappear after each user completes it.-->
                            <app-form-label *ngIf="feedbackForm.get('repeatOptions')?.value === 'yearly'"
                              [type]="'content'" [class]="'text-muted fs-small'"
                              [label]="('FEEDBACKREPEATYEARLYDESCRIPTION' | translate)"></app-form-label>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex align-items-center flex-wrap gap-1">
                        <app-form-label [label]="('FEEDBACKREPEATENDSLABEL' | translate)"></app-form-label>
                        <app-form-label [type]="'content'" [class]="'text-secondary fs-small fw-bold'"
                          [label]="'(' + ('OPTIONALLABEL' | translate) +')'"></app-form-label>
                      </div>
                      <div class="d-flex align-items-center flex-wrap gap-1">
                        <div class="col-12 col-md-6">
                          <app-form-date-time [fG]="feedbackForm" [fCN]="'on_date_time_start'"
                            [placeholder]="'FEEDBACKREPEATENDSPLACEHOLDER' | translate"></app-form-date-time>
                        </div>
                      </div>
                    </div>

                    <div class="card p-card mb-3">
                      <div class="d-flex align-items-center flex-wrap gap-1">
                        <app-form-label [label]="('FEEDBACKDEDLINELABEL' | translate)"></app-form-label>
                        <app-form-label [type]="'content'" [class]="'text-secondary fs-small fw-bold'"
                          [label]="'(' + ('OPTIONALLABEL' | translate) +')'"></app-form-label>
                      </div>
                      <div class="d-flex align-items-center flex-wrap gap-1">
                        <app-form-label [class]="'fs-small'" [type]="'content'"
                          [label]="('FEEDBACKDEADLINEPARTICIPANTSHAVETIMETEXT' | translate)"></app-form-label>
                        <div class="col-md-4 col-12">
                          <app-form-date-time [fG]="feedbackForm" [fCN]="'deadline_date'"
                            [placeholder]="'FEEDBACKDEADLINEDATEPLACEHOLDER' | translate"></app-form-date-time>
                        </div>
                        <app-form-label [class]="'fs-small'" [type]="'content'"
                          [label]="('FEEDBACKDEADLINEPARTICIPANTCOMPLETETEXT' | translate)"></app-form-label>
                      </div>
                      <!-- Display Only if Deadline is set -->
                      <div class="d-flex flex-column mt-3">
                        <!-- Text: This deadline duration will be applied to future feedback repetitions. -->
                        <app-content [fontSize]="'fs-small'"
                          [fontColor]="'text-muted'">{{'FEEDBACKDEADLINEDURATIONDESCRIPTIONTEXT' |
                          translate}}</app-content>
                        <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                          [fontDecoration]="'fw-bold'">Deadline: 13 days, 11 hours, 30 minutes, after feedback is
                          available.</app-content>
                      </div>
                    </div>

                    <!--Display always, except if NO REPEAT and DEADLINE date is not set!-->
                    <div class="card p-card mb-3">
                      <div class="d-flex align-items-center flex-wrap gap-1">
                        <app-form-label [label]="('FEEDBACKREMINDERLABEL' | translate)"></app-form-label>
                        <app-form-label [type]="'content'" [class]="'text-secondary fs-small fw-bold'"
                          [label]="'(' + ('OPTIONALLABEL' | translate) +')'"></app-form-label>
                      </div>
                      <div class="mb-2">
                        <app-form-label [class]="'fs-small'" [type]="'content'"
                          [label]="('FEEDBACKREMINDERSMALLDESCRIPTION' | translate)"></app-form-label>
                      </div>
                      <div class="d-flex align-items-center gap-1 mb-3">
                        <div class="col-4 col-md-3">
                          <app-form-numeric [fG]="feedbackForm" [fCN]="'days_before_deadline'"></app-form-numeric>
                        </div>
                        <app-form-label [class]="'fs-small'" [type]="'content'"
                          [label]="('FEEDBACKREMINDERDAYSBEFORETEXT' | translate)"></app-form-label>
                      </div>
                      <div class="d-flex align-items-center gap-1 mb-3">
                        <div class="col-4 col-md-3">
                          <app-form-numeric [fG]="feedbackForm" [fCN]="'hours_before_deadline'"></app-form-numeric>
                        </div>
                        <app-form-label [class]="'fs-small'" [type]="'content'"
                          [label]="('FEEDBACKREMINDERHOURSBEFORETEXT' | translate)"></app-form-label>
                      </div>
                      <app-form-label [label]="'FEEDBACKREMINDERMESSAGELABEL' | translate" [maxChars]="100"
                        [currentChars]="feedbackForm.controls['reminder_message'].value.length"></app-form-label>
                      <div class="col-12">
                        <app-form-textarea [placeholder]="('FEEDBACKREMINDERMESSAGEPLACEHOLDER' | translate)"
                          [fCN]="'reminder_message'" [fG]="feedbackForm" [rows]="4"></app-form-textarea>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="7">
                    <app-form-label [label]="'FEEDBACKSUMMARYSTATISTICSLABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-6">
                        <app-form-checkbox [fCN]="'summarystats_for_users'" [fG]="feedbackForm"
                          [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                          [label]="'FEEDBACKENABLESUMMARYSTATSFORUSERSTEXT'"></app-form-checkbox>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngSwitchCase="8">
                    <app-form-label [label]="'FEEDBACKANONYMITYLABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-6">
                        <app-form-checkbox [fCN]="'anonym_feedback'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                          [labelPosition]="'After'" [label]="'FEEDBACKWILLNOTSAVEUSERINFOTEXT'"></app-form-checkbox>
                      </div>
                    </div>
                    <app-form-label [label]="'FEEDBACKTYPELABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-12 col-md-6">
                        <app-form-radio [fG]="feedbackForm" [fCN]="'feedback_type'" [value]="'optional'"
                          [placeholder]="'FEEDBACKISOPTIONALLABEL' | translate"
                          [cssClass]="'e-normal'"></app-form-radio>
                      </div>
                      <div class="col-12 col-md-6">
                        <app-form-radio [fG]="feedbackForm" [fCN]="'feedback_type'" [value]="'mandatory'"
                          [placeholder]="'FEEDBACKISMANDATORYLABEL' | translate"
                          [cssClass]="'e-normal'"></app-form-radio>
                      </div>
                    </div>
                    <app-form-label [label]="'FEEDBACKALLOWRETAKELABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-6">
                        <app-form-checkbox [fCN]="'allow_retaking_feedback'" [fG]="feedbackForm"
                          [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                          [label]="'FEEDBACKALLOWRETAKETEXT'"></app-form-checkbox>
                      </div>
                    </div>
                    <app-form-label [label]="'FEEDBACKQUESTIONSDISPLAYLAYOUTLABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-6">
                        <!-- Each question is displayed individually, and users must click “Next” to proceed. You can also set a timer for each question or add “Skip Logic” to answers.-->
                        <app-tooltip [tooltipTarget]="'.oneatatime-tip'"
                          [text]="('FEEDBACKONEATATIMETOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                          [height]="'auto'">
                          <app-form-radio [fG]="feedbackForm" [fCN]="'question_display_style'" [value]="'one_at_a_time'"
                            [placeholder]="'FEEDBACKQUESTIONSONEATATIMELABEL' | translate"
                            [cssClass]="'e-normal oneatatime-tip'"></app-form-radio>
                        </app-tooltip>
                        <!--<app-form-checkbox [fCN]="'display_one_ata_time'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'" [label]="'FEEDBACKQUESTIONSONEATATIMETEXT'"></app-form-checkbox>-->
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-6">
                        <!-- All questions are displayed on a single screen, with each question shown in its own card. -->
                        <app-tooltip [tooltipTarget]="'.multiplecard-tip'"
                          [text]="('FEEDBACKMULTIPLECARDSTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                          [height]="'auto'">
                          <app-form-radio [fG]="feedbackForm" [fCN]="'question_display_style'"
                            [value]="'multiple_cards'" [placeholder]="'FEEDBACKQUESTIONSMULTIPLECARDSLABEL' | translate"
                            [cssClass]="'e-normal multiplecard-tip'"></app-form-radio>
                        </app-tooltip>
                      </div>
                    </div>
                    <div class="row mb-3">
                      <div class="col-6">
                        <!--All questions are displayed as a single form. Titles and descriptions should not be included with individual questions.-->
                        <app-tooltip [tooltipTarget]="'.singleform-tip'"
                          [text]="('FEEDBACKSINGLEFORMTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                          [height]="'auto'">
                          <app-form-radio [fG]="feedbackForm" [fCN]="'question_display_style'" [value]="'single_form'"
                            [placeholder]="'FEEDBACKSINGLEFORMLABEL' | translate"
                            [cssClass]="'e-normal singleform-tip'"></app-form-radio>
                        </app-tooltip>
                      </div>
                    </div>
                    <app-form-label [label]="'FEEDBACKQUESTIONSDISPLAYNUMBERLABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-6">
                        <app-form-checkbox [fCN]="'is_display_question_number'" [fG]="feedbackForm"
                          [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                          [label]="'FEEDBACKQUESTIONSDISPLAYNUMBERTEXT'"></app-form-checkbox>
                      </div>
                    </div>
                    <app-form-label [label]="'FEEDBACKINFORMPARTICIPANTSVIAPUSHLABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-6">
                        <app-form-checkbox [fCN]="'inform_via_push'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                          [labelPosition]="'After'"
                          [label]="'FEEDBACKINFORMPARTICIPANTSVIAPUSHTEXT'"></app-form-checkbox>
                      </div>
                    </div>
                    <app-form-label [label]="'FEEDBACKSENDEMAILWHENUSERCOMPLETESLABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-6">
                        <app-form-checkbox [fCN]="'email_when_user_completes'" [fG]="feedbackForm"
                          [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                          [label]="'FEEDBACKSENDEMAILWHENUSERCOMPLETESTEXT'"></app-form-checkbox>
                      </div>
                    </div>
                    <app-form-label [label]="'FEEDBACKCREATEPUBLICLINKLABEL' | translate"></app-form-label>
                    <div class="row mb-3">
                      <div class="col-6">
                        <app-form-checkbox [fCN]="'create_public_link'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                          [labelPosition]="'After'" [label]="'FEEDBACKCREATEPUBLICLINKTEXT'"></app-form-checkbox>
                      </div>
                      <div *ngIf="feedbackForm.get('create_public_link')?.value" class="col-12">
                        <app-form-input [placeholder]="''" [label]="('FEEDBACKPUBLICLINK' | translate)"
                          [fCN]="'feedback_public_link'" [fG]="feedbackForm" [iconBack]="'content_copy'"
                          [iconClickType]="'back'"></app-form-input>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </form>
            </div>

            <div class="d-flex justify-content-between mt-3 d-none d-md-flex">
              <app-form-button [text]="'PREV' | translate" *ngIf="activeStep > 0" (click)="activeStep = activeStep - 1"
                [cssClass]="'e-outline w-20'"></app-form-button>
              <app-form-button [text]="'NEXT' | translate" *ngIf="activeStep < steps.length - 1"
                (click)="activeStep = activeStep + 1" [cssClass]="'e-secondary ms-auto w-20'"></app-form-button>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-md-none d-flex gap-2 p-2">
          <div class="flex-shrink-0">
            <app-form-button [text]="'PREV' | translate" *ngIf="activeStep > 0" (click)="activeStep = activeStep - 1"
              [cssClass]="'e-outline w-100 mx-1'"></app-form-button>

            <!-- Dummy button to keep the space for the flex container -->
            <app-form-button *ngIf="activeStep === 0" [text]="'PREV' | translate"
              [cssClass]="'e-outline invisible w-100 mx-1'"></app-form-button>
          </div>
          <div class="flex-grow-1 d-flex justify-content-center">
            <app-form-button [text]="'CREATEFEEDBACK' | translate" [disabled]="feedbackForm.invalid"
              (click)="onOpenDialog($event,'start-feedbackcomposer')" [cssClass]="'e-primary w-90'"></app-form-button>
          </div>
          <div class="flex-shrink-0">
            <app-form-button [text]="'NEXT' | translate" *ngIf="activeStep < steps.length - 1"
              (click)="activeStep = activeStep + 1" [cssClass]="'e-secondary w-100 mx-1'"></app-form-button>

            <!-- Dummy button to keep the space for the flex container -->
            <app-form-button [text]="'NEXT' | translate" *ngIf="activeStep === steps.length - 1"
              [cssClass]="'e-secondary invisible w-100 mx-1'"></app-form-button>
          </div>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog Feedback Creator -->
    <ejs-dialog target=".dialogs" class="wide-creator-dialog" [visible]='false'
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' #showFeedbackCreate
      [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'50%'"
      [height]="'95vh'" [zIndex]="999" [showCloseIcon]="true" (beforeClose)="saveFeedbackForm($event)"
      (open)="onOpenDialogPreventFocus($event)">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKDESIGNERTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKDESIGNERHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="d-flex flex-column h-100">
          <div class="d-flex justify-content-between align-items-center px-3 pt-3">
            <app-headline [type]="'h6'" [title]="('UNSAVED' | translate)"
              [class]="'text-danger fw-bold'"></app-headline>
            <div class="d-flex align-items-center gap-1">
              <app-tooltip [tooltipTarget]="'.saveform-icon'" [text]="('FEEDBACKSAVEFORMTOOLTIP' | translate)"
                [type]="'Default'" [width]="'auto'" [height]="'auto'">
                <app-form-button (click)="fakeMethod()"
                  [cssClass]="'saveform-icon e-btn e-flat fs-normal text-primary p-1'" [icon]="'save'"
                  [iconClass]="'fs-4 mts-icon-filled  m-1'"></app-form-button>
              </app-tooltip>
              <app-tooltip [tooltipTarget]="'.globalsettings-icon'"
                [text]="('FEEDBACKGLOBALSETTINGSTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                [height]="'auto'">
                <app-form-button (click)="onOpenDialog($event,'create-newfeedback')"
                  [cssClass]="'globalsettings-icon e-btn e-flat fs-normal text-muted p-1'" [icon]="'settings'"
                  [iconClass]="'fs-4 mts-icon-filled m-1'"></app-form-button>
              </app-tooltip>
              <app-tooltip [tooltipTarget]="'.previewform-icon'" [text]="('FEEDBACKPREVIEWTOOLTIP' | translate)"
                [type]="'Default'" [width]="'auto'" [height]="'auto'">
                <app-form-button (click)="onOpenDialog($event,'start-feedbackpreview')"
                  [cssClass]="'previewform-icon e-btn e-flat fs-normal text-muted p-1'" [icon]="'preview'"
                  [iconClass]="'fs-4 mts-icon-filled  m-1'"></app-form-button>
              </app-tooltip>
              <app-form-button [text]="'FEEDBACKPUBLISHBUTTON' | translate" (click)="fakeMethod()"
                [cssClass]="'e-btn e-primary fw-semibold d-none d-md-flex'"></app-form-button>
            </div>
          </div>
          <div class="d-md-none d-flex align-items-center justify-content-end px-3 pt-1">
            <app-form-button [text]="'FEEDBACKPUBLISHBUTTON' | translate" (click)="fakeMethod()"
              [cssClass]="'e-btn e-primary fw-semibold'"></app-form-button>
          </div>
          <!-- SCrollable content-->
          <div class="custom-scrollbar overflow-y-auto my-3 p-3">
            <app-headline [title]="'Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.'"
              [type]="'h5'" [class]="'text-primary fw-bold'"></app-headline>
            <div class="mt-2">
              <app-content [type]="'richtext'" [expandable]="false"
                [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <app-form-button [text]="'SHOWATTACHMENTS' | translate" (click)="true"
                [cssClass]="'e-btn e-flat fw-bold fs-small text-muted p-1'" [icon]="'attach_file'"
                [iconPosition]="'left'" [iconClass]="'fs-5'" [hideTextOnMobile]="false"></app-form-button>
            </div>
            <div class="my-3">
              <div class="input-group">
                <input type="text" class="form-control"
                  [placeholder]="('FEEDBACKCREATEENTRYINPUTPLACEHOLDERTEXT' | translate)"
                  aria-label="FEEDBACKCREATEENTRYINPUTPLACEHOLDERTEXT" aria-describedby="feedback-title-input"
                  maxlength="250">
                <button class="btn btn-outline-light" type="button"><span class="mts-icon fs-5">close</span></button>
                <button class="btn btn-secondary px-md-5 px-sm-2" type="button"
                  (click)="onOpenDialog($event,'show-questiontype')">{{ 'FEEDBACKCREATEENTRYBUTTONTEXT' | translate
                  }}</button>
              </div>
            </div>

            <!--QUESTION CARD -->
            <div class="card feedbackCard my-3" [class.inactive]="isDisabledQuestion"
              [class.mandatory_question]="isMandatoryQuestion">
              <div class="card-body">
                <!-- Question Numbering and Options -->
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <app-headline [title]="'Q1.'" [type]="'h6'"
                      [class]="'fw-bold' + ' ' +(isMandatoryQuestion ? 'text-danger' : 'text-primary')"></app-headline>
                    <span *ngIf="isMandatoryQuestion" class="text-danger fs-5">*</span>
                  </div>
                  <div class="d-flex align-items-center">
                    <!-- Show Attachments of the question and Question Settings -->
                    <div *ngIf="questionHasAttachments">
                      <app-tooltip [tooltipTarget]="'.question-attachments'"
                        [text]="('FEEDBACKQUESTIONSHOWATTACHMENTTOOLTIP' | translate)" [type]="'Default'"
                        [width]="'auto'" [height]="'auto'">
                        <app-form-button (click)="showAttachments()"
                          [cssClass]="'question-attachments e-btn e-flat fs-normal text-muted p-1'"
                          [icon]="'attach_file'" [iconClass]="'fs-5 m-1'"></app-form-button>
                      </app-tooltip>
                    </div>
                    <div *ngIf="isQuestionExpanded">
                      <app-tooltip [tooltipTarget]="'.question-collapse'"
                        [text]="('FEEDBACKQUESTIONCOLLAPSETOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                        [height]="'auto'">
                        <app-form-button (click)="toggleExpanded()"
                          [cssClass]="'question-collapse e-btn e-flat fs-normal text-muted p-1'"
                          [icon]="'expand_circle_up'" [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                      </app-tooltip>
                    </div>
                    <div *ngIf="!isQuestionExpanded">
                      <app-tooltip [tooltipTarget]="'.question-expande'"
                        [text]="('FEEDBACKQUESTIONEXPANDTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                        [height]="'auto'">
                        <app-form-button (click)="toggleExpanded()"
                          [cssClass]="'question-expande e-btn e-flat fs-normal text-muted p-1'"
                          [icon]="'expand_circle_down'" [iconClass]="'mts-icon-filled fs-4 m-1'"></app-form-button>
                      </app-tooltip>
                    </div>
                    <div class="dropdown">
                      <div data-bs-toggle="dropdown" aria-expanded="false">
                        <app-tooltip [tooltipTarget]="'.question-options'"
                          [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                          [height]="'auto'">
                          <app-form-button [cssClass]="'question-options e-btn e-flat fs-normal text-muted p-1'"
                            [icon]="'settings'" [iconClass]="'fs-5 mts-icon-filled m-1'"
                            [attr.aria-label]="('QUESTIONOPTIONS' | translate)"></app-form-button>
                        </app-tooltip>
                      </div>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <li><app-link (click)="markAsMandatory()"
                            [title]="('FEEDBACKQUESTIONMARKMANDATORYMENU' | translate)" [style]="'dropdown'">{{
                            ('FEEDBACKQUESTIONMARKMANDATORYMENU' | translate) }}</app-link></li>
                        <li><app-link (click)="onOpenDialog($event,'show-answertimelimit')"
                            [title]="('FEEDBACKQUESTIONANSWERTIMEMENU' | translate)" [style]="'dropdown'">{{
                            ('FEEDBACKANSWERTIMEMENU' | translate) }}</app-link></li>
                        <li><app-link (click)="onOpenDialog($event,'show-question-description')"
                            [title]="('FEEDBACKQUESTIONMANAGETITLEDESCRIPTIONMENU' | translate)" [style]="'dropdown'">{{
                            ('FEEDBACKQUESTIONMANAGETITLEDESCRIPTIONMENU' | translate) }}</app-link></li>
                        <li><app-link (click)="addAttachmentToQuestion()"
                            [title]="('FEEDBACKQUESTIONADDFILESMENU' | translate)" [style]="'dropdown'">{{
                            ('FEEDBACKQUESTIONADDFILESMENU' | translate) }}</app-link></li>
                        <li><app-link (click)="disableQuestion()"
                            [title]="('FEEDBACKQUESTIONDISABLEQUESTIONMENU' | translate)" [style]="'dropdown'">{{
                            ('FEEDBACKQUESTIONDISABLEQUESTIONMENU' | translate) }}</app-link></li>
                        <li><app-link (click)="fakeMethod()"
                            [title]="('FEEDBACKQUESTIONDELETEQUESTIONMENU' | translate)" [style]="'dropdown'">{{
                            ('FEEDBACKQUESTIONDELETEQUESTIONMENU' | translate) }}</app-link></li>
                      </ul>
                    </div>
                    <!-- Question Type Badge-->
                    <span class="badge ms-1 bg-faintgreen brd-success border text-success fs-default">Einfachauswahl</span>
                  </div>
                </div>

                <div class="d-flex">
                  <!-- Arrows Up and Down -->
                  <div class="flex-column align-items-center justify-content-center pe-2 gap-3 d-none d-md-flex">
                    <app-tooltip [tooltipTarget]="'.moveup-arrow'" [text]="'Move Question Up'" [type]="'Default'"
                      [width]="'auto'" [height]="'auto'">
                      <app-icon-badge [style]="'default'" [icon]="'arrow_upward'" [fontSize]="'fs-3'"
                        [class]="'moveup-arrow text-skyblue cursor-pointer'"></app-icon-badge>
                    </app-tooltip>
                    <app-tooltip [tooltipTarget]="'.movedown-arrow'" [text]="'Move Question Down'" [type]="'Default'"
                      [width]="'auto'" [height]="'auto'">
                      <app-icon-badge [style]="'default'" [icon]="'arrow_downward'" [fontSize]="'fs-3'"
                        [class]="'movedown-arrow text-skyblue cursor-pointer'"></app-icon-badge>
                    </app-tooltip>
                  </div>
                  <!-- Forms Container -->
                  <div class="d-flex flex-column flex-grow-1 justify-content-start">
                    <div class="mt-3">
                      <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                        [title]="'Wie bewerten Sie die Effizienz und Wirksamkeit des Managements in Ihrem Arbeitsalltag?'"></app-headline>
                    </div>
                    <!-- Description of the question -->
                    <div class="d-flex mt-3">
                      <app-content [type]="'richtext'"
                        [innerHTML]="'Bitte berücksichtigen Sie bei Ihrer Bewertung Aspekte wie Kommunikation, Entscheidungsfindung, Unterstützung durch Führungskräfte sowie die Fähigkeit des Managements, klare Ziele und Erwartungen zu vermitteln..'"></app-content>
                    </div>
                    <!-- REQUIRED BUT COMMENTED FOR PRESENTATION PURPOSE: Add this if there is not title nor description 
                    <div class="d-flex justify-content-center my-3">
                      <app-headline [type]="'h6'" [class]="'text-secondary fw-bold'"
                        [title]="'FEEDBACKNOTITLEANDDESCRIPTION' | translate"></app-headline>
                    </div> -->

                    <!-- Main Question Form Container -->
                    <div [class.d-none]="!isQuestionExpanded" class="d-flex flex-column my-3">

                      <!-- Radio Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <!-- Bordered container with form and option icons -->
                        <div class="d-flex flex-column border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'"
                                [fontDecoration]="'fw-bold'">Richtige Antwort</app-content>
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-logic')"
                                      [title]="('FEEDBACKOPTIONADDLOGICMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONADDLOGICMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex">
                              <app-form-label [label]="'Wie zufrieden sind Sie mit unserem Service?'"></app-form-label>
                            </div>

                            <!-- Radio and Label Input -->
                            <div class="d-flex gap-2 w-100">
                              <div class="d-flex align-items-center gap-1 flex-grow-1">
                                <div class="pb-1">
                                  <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                    [placeholder]="' '"></app-form-radio>
                                </div>
                                <div class="w-100">
                                  <app-form-input [placeholder]="('FEEDBACKTYPEOPTIONLABELHOLDER' | translate)"
                                    [label]="('FEEDBACKTYPEOPTIONLABELHOLDER' | translate)"
                                    [fCN]="'feedback_radio_label1'" [fG]="feedbackForm" [maxChars]="60"
                                    [hasErrorField]="false"></app-form-input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!--Notification that the answer will require a comment from the user-->
                          <div class="d-flex justify-content-end">
                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                              [fontDecoration]="'fw-bold'">{{('FEEDBACKANSWERWILLREQUIRECOMMENTTEXT' |
                              translate)}}</app-content>
                          </div>
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Checkbox Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <!-- Bordered container with form and option icons -->
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'"
                                [fontDecoration]="'fw-bold'">Richtige Antwort</app-content>
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-logic')"
                                      [title]="('FEEDBACKOPTIONADDLOGICMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONADDLOGICMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex">
                              <app-form-label [label]="'Welche Benefits schätzen Sie am meisten?'"></app-form-label>
                            </div>

                            <!-- Checkbox and Label Input -->
                            <div class="d-flex gap-2 w-100">
                              <div class="d-flex align-items-center gap-1 flex-grow-1">
                                <div class="pb-1 pe-1">
                                  <app-form-checkbox [fCN]="'checkbox_option'" [fG]="feedbackForm" [cssClass]="''"
                                    [cssClass]="'pb-1 lh-base'"></app-form-checkbox>
                                </div>
                                <div class="w-100">
                                  <app-form-input [placeholder]="('FEEDBACKTYPEOPTIONLABELHOLDER' | translate)"
                                    [label]="('FEEDBACKTYPEOPTIONLABELHOLDER' | translate)"
                                    [fCN]="'feedback_radio_label1'" [fG]="feedbackForm" [maxChars]="60"
                                    [hasErrorField]="false"></app-form-input>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!--Notification that the answer will require a comment from the user-->
                          <div class="d-flex justify-content-end">
                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                              [fontDecoration]="'fw-bold'">{{('FEEDBACKANSWERWILLREQUIRECOMMENTTEXT' |
                              translate)}}</app-content>
                          </div>
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Image choice Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <!-- Bordered container with form and option icons -->
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'"
                                [fontDecoration]="'fw-bold'">Richtige Antwort</app-content>
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-logic')"
                                      [title]="('FEEDBACKOPTIONADDLOGICMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONADDLOGICMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex">
                              <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>

                            <!-- Radio and Image -->
                            <div class="d-flex align-items-center gap-1 flex-grow-1">
                              <div class="d-flex pb-1">
                                <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                                  [placeholder]="' '"></app-form-radio>
                              </div>
                              <div class="w-100 d-flex align-items-center gap-1">
                                <!-- I cannot use your component bellow because I cannot add a truncate-text-one-line class on the span with the text-->
                                <app-tooltip *ngIf="!thereIsAnImageUploaded" [tooltipTarget]="'.uploadimage-icon'"
                                  [text]="('FEEDBACKQUESTIONUPLOADIMAGETOOLTIP' | translate)">
                                  <div class="uploadimage-icon d-flex align-items-center gap-1 cursor-pointer px-1"
                                    tabindex="0">
                                    <span class="mts-icon fs-4 text-muted">add_photo_alternate</span>
                                    <span class='fs-default text-muted truncate-text-one-line'>{{
                                      ('FEEDBACKQUESTIONUPLOADIMAGEBUTTON' | translate) }}</span>
                                  </div>
                                </app-tooltip>

                                <div *ngIf="thereIsAnImageUploaded" class="image-choice-imagepreview video-playoverlay">
                                  <img
                                    [src]="'https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80'"
                                    alt="Uploaded" appNgSrcImageError>
                                </div>

                                <div *ngIf="thereIsAnImageUploaded" class="d-flex justify-content-center">
                                  <app-tooltip [tooltipTarget]="'.replaceimage-icon'"
                                    [text]="('FEEDBACKQUESTIONREPLACEIMAGETOOLTIP' | translate)" [type]="'Default'"
                                    [width]="'auto'" [height]="'auto'">
                                    <app-form-button (click)="fakeMethod()"
                                      [cssClass]="'replaceimage-icon e-btn e-flat text-muted p-0'"
                                      [icon]="'replace_image'" [iconClass]="'fs-4 m-1'"></app-form-button>
                                  </app-tooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Slider Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <!-- Bordered container with form and option icons -->
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'"
                                [fontDecoration]="'fw-bold'">Richtige Antwort</app-content>
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20/User selected value</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-slidersettings')"
                                      [title]="('FEEDBACKSLIDERSETTINGSDMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKSLIDERSETTINGSDMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-logic')"
                                      [title]="('FEEDBACKOPTIONADDLOGICMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONADDLOGICMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex">
                              <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>

                            <!-- Slider -->
                            <div class="d-flex px-3 py-1">
                              <!-- You must create value rules in the form otherwise the values will freez the browser if they are not in correct ranges -->
                              <!-- The [value] is the initial position of the slider, this must be in the [min] and [max] range-->
                              <!-- The [step] defines the handle steps, this must be in the [min] and [max] range-->
                              <!-- [min] should be less than [max]-->
                              <!-- largeStep > smallStep and between [min] and [max]-->
                              <ejs-slider [type]="'MinRange'" [value]="initialValue" [min]="minInterval"
                                [max]="maxInterval" [ticks]="ticks" [step]="handleSteps" [tooltip]="tooltip"
                                (tooltipChange)='tooltipChangeHandler($event)' [enabled]="true"
                                (renderingTicks)='renderingTicksHandler($event)'></ejs-slider>
                            </div>
                          </div>

                          Notification that the answer will require a comment from the user
                          <div class="d-flex justify-content-end">
                            <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                              [fontDecoration]="'fw-bold'">{{('FEEDBACKANSWERWILLREQUIRECOMMENTTEXT' |
                              translate)}}</app-content>
                          </div>
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Rating Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <!-- Bordered container with form and option icons -->
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'"
                                [fontDecoration]="'fw-bold'">Richtige Antwort</app-content>
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20/User selected value</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-ratingsettings')"
                                      [title]="('FEEDBACKRATINGSETTINGSDMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKRATINGSETTINGSDMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-logic')"
                                      [title]="('FEEDBACKOPTIONADDLOGICMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONADDLOGICMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex flex-column align-items-center w-100">
                              <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>

                            <!-- Rating -->
                            <div class="d-flex flex-column">
                              <input ejs-rating value="0" showLabel="true" labelPosition="Top" precision="Half"
                                allowReset="true" [disabled]="false" />
                            </div>
                          </div>

                          1. Remove checkboxes in Answer Options, if we can only have one rating per question? We need
                          to talk about it
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Text Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <!-- Bordered container with form and option icons -->
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'"
                                [fontDecoration]="'fw-bold'">Richtige Antwort</app-content>
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-logic')"
                                      [title]="('FEEDBACKOPTIONADDLOGICMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONADDLOGICMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex">
                              <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>

                            <!-- Text Field -->
                            <div class="d-flex flex-column align-items-start flex-grow-1">
                              <div class="w-100">
                                <app-form-textarea [placeholder]="('FEEDBACKQUESTIONTEXTPLACEHOLDER' | translate)"
                                  [fCN]="'feedback_text'" [fG]="feedbackForm" [maxChars]="250"
                                  [rows]="4"></app-form-textarea>
                              </div>
                            </div>

                            1. If question is mandatory, hide the 'Add Logic' option! 2. Remove Mandatory comment
                            checkbox from the Answer Options
                          </div>
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Dropdown Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <app-content [fontSize]="'fs-small'" [fontColor]="'text-primary'"
                                [fontDecoration]="'fw-bold'">Richtige Antwort</app-content>
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-logic')"
                                      [title]="('FEEDBACKOPTIONADDLOGICMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONADDLOGICMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dropdown -->
                            <div class="d-flex">
                              <div class="w-100">
                                <app-form-input [placeholder]="('FEEDBACKDROPDOWNITEMPLACEHOLDER' | translate)"
                                  [fCN]="'dropdown_item'" [fG]="feedbackForm" [maxChars]="40" [hasErrorField]="false"
                                  [cssClass]="'flex-grow-1'"></app-form-input>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Reorder List Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <!-- Bordered container with form and option icons -->
                        <div class="d-flex flex-column border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-logic')"
                                      [title]="('FEEDBACKOPTIONADDLOGICMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONADDLOGICMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!--Dynamic label-->
                            <div class="d-flex">
                              <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>

                            <div class="d-flex">
                              <!-- Reoderable List -->
                              <div class="w-100">
                                <!-- Reoder list FIRST element -->
                                <div class="card mb-2">
                                  <div class="d-flex align-items-stretch">
                                    <div class="d-flex align-items-center justify-content-center border-end p-2">
                                      <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                                        [fontDecoration]="'fw-bold'">a.</app-content>
                                    </div>
                                    <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                                      <!--<app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">This is a option in reordarable list</app-content>  -->
                                      <div class="w-100">
                                        <app-form-input
                                          [placeholder]="('FEEDBACKREORDERABLEITEMPLACEHOLDER' | translate)"
                                          [fCN]="'feedback_reordarable_items'" [fG]="feedbackForm" [maxChars]="200"
                                          [hasErrorField]="false"></app-form-input>
                                      </div>
                                    </div>
                                    <!--<div class="d-flex align-items-center justify-content-center border-start px-2">
                                        <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'" [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                                        <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'" [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                                      </div>-->
                                    <div
                                      class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                                      <app-form-button (click)="true" [cssClass]="'e-link text-muted p-0'"
                                        [icon]="'delete'"></app-form-button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          1. The points can be set based on the desired order. 2. The answer settings should not have
                          the checkboxes!
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Date/Time Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex">
                              <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>

                            <!-- Date/Time Picker -->
                            <div class="d-flex w-md-50">
                              <div class="w-100">
                                <app-form-date-time [fG]="feedbackForm" [fCN]="'datetime_answer'"
                                  [disabled]="true"></app-form-date-time>
                              </div>
                            </div>
                          </div>

                          1. No Logic 2. Remove cheboxe in Answer options 3. No 'Add Option button', since it's only one
                          field
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Date Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex">
                              <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>

                            <!-- Date Picker -->
                            <div class="d-flex w-md-50">
                              <div class="w-100">
                                <app-form-date [fG]="feedbackForm" [fCN]="'date_asnwer'"
                                  [disabled]="true"></app-form-date>
                              </div>
                            </div>
                          </div>

                          1. No Logic 2. Remove chebox in Answer options 3. No 'Add Option button', since it's only one
                          field
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Time Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="onOpenDialog($event,'show-answerlabel')"
                                      [title]="('FEEDBACKANSWERLABELMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKANSWERLABELMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <!-- Dynamic Label -->
                            <div class="d-flex">
                              <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                            </div>

                            <!-- Time Picker -->
                            <div class="d-flex w-md-50">
                              <div class="w-100">
                                <ejs-timepicker [placeholder]="'SELECTTIME' | translate" [enabled]="false"
                                  [value]='dateValue' [format]='formatString' [step]='interval' [min]='minValue'
                                  [max]='maxValue'></ejs-timepicker>
                              </div>
                            </div>
                          </div>

                          1. No Logic 2. Remove chebox in Answer options 3. No 'Add Option button', since it's only one
                          field
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- File upload Type -->
                      <div class="d-flex align-items-center mb-2">
                        <!-- Orange Logic icon -->
                        <div class="icon-placeholder text-center">
                          <app-tooltip [tooltipTarget]="'.logic-icon'"
                            [text]="('FEEDBACKQUESTIONCLICKTOVIEWLOGICTOOLTIP' | translate)" [type]="'Default'"
                            [width]="'auto'" [height]="'auto'">
                            <app-icon-badge (click)="onOpenDialog($event,'show-logic')" [style]="'default'"
                              [icon]="'move_down'" [fontSize]="'fs-3'"
                              [class]="'logic-icon text-orange cursor-pointer'"></app-icon-badge>
                          </app-tooltip>
                        </div>
                        <div class="d-flex flex-column flex-grow-1 border rounded p-2 gap-2 w-100">
                          <!-- Info and Options Dropdown -->
                          <div class="d-flex align-items-center justify-content-between gap-1">
                            <div class="d-flex align-items-center flex-wrap gap-2">
                              <div class="d-flex align-items-center gap-1">
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'">Punkte:</app-content>
                                <app-content [fontSize]="'fs-small'" [fontColor]="'text-muted'"
                                  [fontDecoration]="'fw-bold'">20</app-content>
                              </div>
                            </div>
                            <div class="ms-auto">
                              <div class="dropdown">
                                <button type="button" class="btn btn-link p-0 text-muted" data-bs-toggle="dropdown"
                                  aria-expanded="false" [attr.aria-label]="('SRMOREOPTIONS' | translate)">
                                  <app-tooltip [tooltipTarget]="'.feedbackoption-icon'"
                                    [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)">
                                    <app-icon-badge [style]="'notification'" [class]="'feedbackoption-icon'"
                                      [icon]="'more_horiz'"></app-icon-badge>
                                  </app-tooltip>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                  <li><app-link (click)="onOpenDialog($event,'show-answersettings')"
                                      [title]="('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate)" [style]="'dropdown'">{{
                                      ('FEEDBACKOPTIONANSWERSETTINGSMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEUPMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEUPMENU' | translate) }}</app-link></li>
                                  <li><app-link (click)="fakeMethod()" [title]="('MOVEDOWNMENU' | translate)"
                                      [style]="'dropdown'">{{ ('MOVEDOWNMENU' | translate) }}</app-link></li>
                                </ul>
                              </div>
                            </div>
                          </div>

                          <div class="my-2">
                            <div class="d-flex">
                              <app-form-label [label]="'FEEDBACKFAKELABELFORDATAUPLOAD' | translate"></app-form-label>
                            </div>

                            <div class="card">
                              <div class="card-body">
                                <div class="d-flex mx-auto justify-content-center">
                                  <div class="d-flex flex-column">
                                    <div class="d-flex align-items-center">
                                      <app-icon-badge [style]="'documents'"></app-icon-badge>
                                      <app-content [fontSize]="'fs-6'" [fontColor]="'text-secondary'"
                                        [class]="'upload-text'">{{ ('FEEDBACKFILEUPLOADEPREVIEWTEXT' | translate)
                                        }}</app-content>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          1. Remove Chekbox in Answer Options 2. No 'Add Option button', because it should be only one
                          file uploader! 3. No logic
                        </div>

                        <!-- Remove Icon -->
                        <div class="remove-icon">
                          <app-tooltip [tooltipTarget]="'.removeoption-icon'"
                            [text]="('FEEDBACKREMOVEANSWERTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                            [height]="'auto'">
                            <app-form-button (click)="fakeMethod()"
                              [cssClass]="'removeoption-icon e-btn e-flat fs-normal text-muted p-0'" [icon]="'close'"
                              [iconClass]="'fs-5 m-1'"></app-form-button>
                          </app-tooltip>
                        </div>
                      </div>

                      <!-- Add New Option -->
                      <div class="add-option">
                        <app-tooltip [tooltipTarget]="'.addoption-icon'"
                          [text]="('FEEDBACKADDOPTIONTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                          [height]="'auto'">
                          <app-form-button [text]="'FEEDBACKADDOPTION' | translate" (click)="fakeMethod()"
                            [cssClass]="'addoption-icon e-btn e-flat fs-6 fw-bold text-primary'" [icon]="'add'"
                            [iconClass]="'fs-5'"></app-form-button>
                        </app-tooltip>
                      </div>
                    </div>
                    <div class="inactive-container d-none justify-content-end">
                      <app-headline [type]="'h6'" [class]="'text-danger fw-bold fs-default m-1'"
                        [title]="'FEEDBACKQUESTIONDISABLEDTEXT' | translate"></app-headline>
                    </div>
                  </div>

                </div>
              </div>
              <div class="card-footer p-card">
                <div class="d-flex justify-content-between align-items-center gap-2">
                  <div class="d-flex align-items-center gap-1">
                    <div class="d-flex d-md-none align-items-center gap-1">
                      <app-tooltip [tooltipTarget]="'.moveup-arrow'" [text]="'Move Question Up'" [type]="'Default'"
                        [width]="'auto'" [height]="'auto'">
                        <app-form-button (click)="fakeMethod()"
                          [cssClass]="'moveup-arrow e-btn e-flat p-0 text-skyblue'" [icon]="'arrow_upward'"
                          [iconClass]="'fs-3 m-0'"></app-form-button>
                      </app-tooltip>
                      <app-tooltip [tooltipTarget]="'.movedown-arrow'" [text]="'Move Question Down'" [type]="'Default'"
                        [width]="'auto'" [height]="'auto'">
                        <app-form-button (click)="fakeMethod()"
                          [cssClass]="'movedown-arrow e-btn e-flat p-0 text-skyblue'" [icon]="'arrow_downward'"
                          [iconClass]="'fs-3 m-0'"></app-form-button>
                      </app-tooltip>
                    </div>
                    <app-tooltip [tooltipTarget]="'.deletequestion-icon'" [text]="'Delete this question'"
                      [type]="'Default'" [width]="'auto'" [height]="'auto'">
                      <app-form-button (click)="fakeMethod()" [cssClass]="'deletequestion-icon e-btn e-flat p-0'"
                        [icon]="'delete'" [iconClass]="'fs-4 m-0 mts-icon-filled'"></app-form-button>
                    </app-tooltip>
                  </div>
                  <div class="d-flex align-items-center gap-md-3 gap-sm-1 flex-wrap">
                    <app-form-checkbox [fCN]="'requires_comment'" [fG]="feedbackForm" [cssClass]="''"
                      [labelPosition]="'After'" [cssClass]="'pb-1 lh-base'"
                      [label]="'FEEDBACKQUESTIONREQUIRESCOMMENTLABEL'"></app-form-checkbox>
                    <app-headline [type]="'h6'" [class]="'text-primary fw-bold fs-default m-1'"
                      [title]="'Answer time: 20s'"></app-headline>
                  </div>
                </div>
              </div>
            </div>

            <!--SCORE EVALUATOR CARD -->
            <div class="card feedbackCard score-logic">
              <div class="card-body">
                <!-- SCORE LOGIC and Options -->
                <div class="d-flex align-items-center justify-content-between">
                  <div class="d-flex align-items-center">
                    <app-headline [title]="'SE.'" [type]="'h6'" [class]="'fw-bold text-orange'"></app-headline>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="dropdown">
                      <div data-bs-toggle="dropdown" aria-expanded="false">
                        <app-tooltip [tooltipTarget]="'.question-options'"
                          [text]="('FEEDBACKQUESTIONOPTIONSTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                          [height]="'auto'">
                          <app-form-button [cssClass]="'question-options e-btn e-flat fs-normal text-muted p-1'"
                            [icon]="'settings'" [iconClass]="'fs-5 mts-icon-filled m-1'"
                            [attr.aria-label]="('QUESTIONOPTIONS' | translate)"></app-form-button>
                        </app-tooltip>
                      </div>
                      <ul class="dropdown-menu dropdown-menu-end">
                        <li><app-link (click)="disableQuestion()"
                            [title]="('FEEDBACKQUESTIONDISABLEQUESTIONMENU' | translate)" [style]="'dropdown'">{{
                            ('FEEDBACKQUESTIONDISABLEQUESTIONMENU' | translate) }}</app-link></li>
                        <li><app-link (click)="fakeMethod()"
                            [title]="('FEEDBACKQUESTIONDELETEQUESTIONMENU' | translate)" [style]="'dropdown'">{{
                            ('FEEDBACKQUESTIONDELETEQUESTIONMENU' | translate) }}</app-link></li>
                      </ul>
                    </div>
                    <!-- Question Type Badge-->
                    <span class="badge ms-1 bg-faintorange brd-orange border text-orange fs-default">Score
                      Evaluator</span>
                  </div>
                </div>

                <div class="d-flex flex-column w-100">
                  <div class="mt-3">
                    <app-content [type]="'default'" [fontSize]="'fs-normal'" [fontColor]="'text-secondary'">This element
                      will not be displayed to the participants. Its sole purpose is to evaluate the scores of all the
                      previous questions and create result screens.</app-content>
                  </div>
                  <!-- Toggle branching score-->
                  <div class="d-flex align-items-center gap-2 my-3">
                    <app-headline [title]="'FEEDBACKTOGGLEBRANCHINGSCORELABEL' | translate" [type]="'h6'"
                      [class]="'text-primary fw-bold'"></app-headline>
                    <app-form-switch [fG]="feedbackForm" [fCN]="'toggle_branching_score'"></app-form-switch>
                  </div>
                  <!--IF SCORE BIGGER THEN x THAN DISPLAY:-->
                  <div *ngIf="isBranchingScore" class="d-flex align-items-center gap-2 flex-wrap">
                    <app-headline [title]="'FEEDBACKSCOREISGREATERTHENLABEL' | translate" [type]="'h6'"
                      [class]="'text-orange fw-bold'"></app-headline>
                    <div class="w-15">
                      <app-form-input [fCN]="'feedback_score_value'" [fG]="feedbackForm" [maxChars]="100"
                        [hasErrorField]="false"></app-form-input>
                    </div>
                    <app-headline [title]="'FEEDBACKSCORETHANLABEL' | translate" [type]="'h6'"
                      [class]="'text-orange fw-bold'"></app-headline>
                  </div>
                  <!-- Description of the question -->
                  <div class="my-3">
                    <div class="card">
                      <div class="card-body">
                        <div class="d-flex align-items-center flex-wrap gap-2">
                          <app-form-checkbox [fCN]="'display_score'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                            [labelPosition]="'After'" [label]="'FEEDBACKDISPLAYSCORELABEL'"></app-form-checkbox>
                          <app-form-checkbox [fCN]="'score_in_percentage'" [fG]="feedbackForm"
                            [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                            [label]="'FEEDBACKSCOREINPERCENTAGELABEL'"></app-form-checkbox>
                          <app-form-checkbox [fCN]="'score_custom_text'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                            [labelPosition]="'After'" [label]="'FEEDBACKSCOREDISPLAYTEXTLABEL'"></app-form-checkbox>
                        </div>
                        <div class="d-flex justify-content-center align-items-center flex-wrap my-5 gap-2">
                          <app-headline [title]="'FEEDBACKSCORERESULT' | translate" [type]="'h5'"
                            [class]="'text-primary fw-bold'"></app-headline>
                          <app-headline [title]="'128'" [type]="'h5'" [class]="'text-primary fw-bold'"></app-headline>
                          <app-headline [title]="'FEEDBACKSCOREPREFIX' | translate" [type]="'h5'"
                            [class]="'text-primary fw-bold'"></app-headline>
                        </div>
                        <app-form-textarea [placeholder]="('FEEDBACKSCOREDESCRIPTION' | translate)"
                          [fCN]="'feedback_score_description1'" [fG]="feedbackForm" [rows]="4" [richText]="true"
                          [maxChars]="500" [class]="'emojiOpenTop emojiSmall'"></app-form-textarea>
                      </div>
                    </div>
                  </div>
                  <!--ELSE DISPLAY SECOND TEXT-->
                  <div *ngIf="isBranchingScore" class="d-flex flex-column gap-1">
                    <app-headline [title]="'FEEDBACKSCOREELSEDISPLAYLABEL' | translate" [type]="'h6'"
                      [class]="'text-orange fw-bold'"></app-headline>
                    <div class="card">
                      <div class="card-body">
                        <div class="d-flex align-items-center flex-wrap gap-2">
                          <app-form-checkbox [fCN]="'display_score'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                            [labelPosition]="'After'" [label]="'FEEDBACKDISPLAYSCORELABEL'"></app-form-checkbox>
                          <app-form-checkbox [fCN]="'score_in_percentage'" [fG]="feedbackForm"
                            [cssClass]="'pb-1 lh-base'" [labelPosition]="'After'"
                            [label]="'FEEDBACKSCOREINPERCENTAGELABEL'"></app-form-checkbox>
                          <app-form-checkbox [fCN]="'score_custom_text'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                            [labelPosition]="'After'" [label]="'FEEDBACKSCOREDISPLAYTEXTLABEL'"></app-form-checkbox>
                        </div>
                        <div class="d-flex justify-content-center align-items-center flex-wrap my-5 gap-2">
                          <app-headline [title]="'FEEDBACKSCORERESULT' | translate" [type]="'h5'"
                            [class]="'text-danger fw-bold'"></app-headline>
                          <app-headline [title]="'128'" [type]="'h5'" [class]="'text-danger fw-bold'"></app-headline>
                          <app-headline [title]="'FEEDBACKSCOREPREFIX' | translate" [type]="'h5'"
                            [class]="'text-danger fw-bold'"></app-headline>
                        </div>
                        <app-form-textarea [placeholder]="('FEEDBACKSCOREDESCRIPTION' | translate)"
                          [fCN]="'feedback_score_description2'" [fG]="feedbackForm" [rows]="4" [richText]="true"
                          [maxChars]="500" [class]="'emojiOpenTop emojiSmall'"></app-form-textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer p-card">
                <div class="d-flex">
                  <app-tooltip [tooltipTarget]="'.deleteevaluator-icon'"
                    [text]="('FEEDBACKDELETESCOREEVALUATORTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                    [height]="'auto'">
                    <app-form-button (click)="fakeMethod()" [cssClass]="'deleteevaluator-icon e-btn e-flat p-0'"
                      [icon]="'delete'" [iconClass]="'fs-4 m-0 mts-icon-filled'"></app-form-button>
                  </app-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog Feedback Preview -->
    <ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='false'
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' #showFeedbackPreview
      [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'40vw'"
      [height]="'70vh'" [zIndex]="999" [showCloseIcon]="true" (open)="onOpenDialogPreventFocus($event)">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKPREVIEWTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKPREVIEWHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="d-flex flex-column h-100">
          <div class="d-flex justify-content-between align-items-center px-3 pt-3">
            <app-headline [type]="'h6'" [title]="('UNSAVED' | translate)"
              [class]="'text-danger fw-bold'"></app-headline>
            <div class="d-flex align-items-center gap-1">
              <app-tooltip [tooltipTarget]="'.backtocreator-icon'"
                [text]="('FEEDBACKPREVIEWCONTINUEEDITINGTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                [height]="'auto'">
                <app-form-button (click)="fakeMethod()"
                  [cssClass]="'backtocreator-icon e-btn e-flat fs-normal text-primary p-1'" [icon]="'edit'"
                  [iconClass]="'fs-4 m-1'"></app-form-button>
              </app-tooltip>
              <app-tooltip [tooltipTarget]="'.feedbackinfo-icon'"
                [text]="('FEEDBACKTOGGLEDESCRIPTIONTOOLTIP' | translate)" [type]="'Default'" [width]="'auto'"
                [height]="'auto'">
                <app-form-button (click)="togleFeedbackInfo()"
                  [cssClass]="'feedbackinfo-icon e-btn e-flat fs-normal text-primary p-1'" [icon]="'info'"
                  [iconClass]="'fs-4 m-1'"></app-form-button>
              </app-tooltip>
              <app-form-button [text]="'FEEDBACKPUBLISHBUTTON' | translate" (click)="fakeMethod()"
                [cssClass]="'e-btn e-primary e-small fw-semibold d-none d-md-flex'"></app-form-button>
            </div>
          </div>
          <div class="d-md-none d-flex align-items-center justify-content-end px-3 pt-1">
            <app-form-button [text]="'FEEDBACKPUBLISHBUTTON' | translate" (click)="fakeMethod()"
              [cssClass]="'e-btn e-primary e-small fw-semibold'"></app-form-button>
          </div>
          <!--Hidden description-->
          <div class="d-flex flex-column p-3" [class.d-none]="toggleFeedbackInfo">
            <app-headline [title]="'Bewerten Sie die Effizienz des Managements, indem Sie diese Umfrage ausfüllen.'"
              [type]="'h5'" [class]="'text-primary fw-bold'"></app-headline>
            <div class="mt-2">
              <app-content [type]="'richtext'" [expandable]="false"
                [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
            </div>
            <div class="d-flex justify-content-end align-items-center">
              <app-form-button [text]="'SHOWATTACHMENTS' | translate" (click)="true"
                [cssClass]="'e-btn e-flat fw-bold fs-small text-muted p-1'" [icon]="'attach_file'"
                [iconPosition]="'left'" [iconClass]="'fs-5'" [hideTextOnMobile]="true"></app-form-button>
            </div>
          </div>
          <!-- SCrollable content-->
          <div class="custom-scrollbar my-3 p-3">

            <!--RADIO add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings-->
            <div class="one-at-atime d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">1</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column ps-md-3">
                <div class="d-flex flex-column">
                  <div class="mt-2">
                    <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                  </div>
                  <div class="mt-2 mb-1">
                    <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                      [placeholder]="'This is the radio dynamic label'" [cssClass]="'e-large'"></app-form-radio>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="mt-2">
                    <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                  </div>
                  <div class="mt-2 mb-1">
                    <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                      [placeholder]="'This is the radio dynamic label'" [cssClass]="'e-large'"></app-form-radio>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="mt-2 mb-1">
                    <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                      [placeholder]="'This is the radio dynamic label'" [cssClass]="'e-large'"></app-form-radio>
                  </div>
                </div>
              </div>
              <!-- If requires mandatory comment -->
              <div class="d-flex flex-column mt-3 ps-md-3 w-100">
                <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                  [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                  [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
              </div>
            </div>

            <!--CHECKBOX add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings-->
            <div class="multicard-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title  d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">2</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'IDiese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column ps-md-3">
                <div class="d-flex flex-column">
                  <div class="mt-2">
                    <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                  </div>
                  <div class="mt-2 mb-1">
                    <app-form-checkbox [fCN]="'checkbox_option'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                      [labelPosition]="'After'" [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="mt-2">
                    <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                  </div>
                  <div class="mt-2 mb-1">
                    <app-form-checkbox [fCN]="'checkbox_option'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                      [labelPosition]="'After'" [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                  </div>
                </div>
                <div class="d-flex flex-column">
                  <div class="mt-2 mb-1">
                    <app-form-checkbox [fCN]="'checkbox_option'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                      [labelPosition]="'After'" [label]="'This is the checkbox dynamic label'"></app-form-checkbox>
                  </div>
                </div>
              </div>
              <!-- If requires mandatory comment -->
              <div class="d-flex flex-column mt-3 ps-md-3 w-100">
                <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                  [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                  [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
              </div>
            </div>

            <!--IMAGE CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title  d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">3</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column w-100">
                <div class="d-flex flex-wrap justify-content-center gap-4 my-3">

                  <!-- Tile 1 -->
                  <div class="image-radio-tile d-flex flex-column align-items-center">
                    <div class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                      <img
                        src="https://www.shutterstock.com/image-vector/survey-form-pencil-vector-illustration-600nw-2656414333.jpg"
                        alt="Sample Image" appNgSrcImageError>
                    </div>

                    <div class="d-flex flex-column align-items-center">
                      <div
                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                          [cssClass]="'e-large mb-3'"></app-form-radio>
                      </div>

                      <div class="d-flex mt-2 p-1">
                        <app-form-label
                          [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                      </div>
                    </div>
                  </div>

                  <!-- Tile 2 -->
                  <div class="image-radio-tile d-flex flex-column align-items-center">
                    <div class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                      <img
                        src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                        alt="Sample Image" appNgSrcImageError>
                    </div>

                    <div class="d-flex flex-column align-items-center">
                      <div
                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                          [cssClass]="'e-large  mb-3'"></app-form-radio>
                      </div>

                      <div class="d-flex mt-2 p-1">
                        <app-form-label
                          [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                      </div>
                    </div>
                  </div>

                  <!-- Tile 3 -->
                  <div class="image-radio-tile d-flex flex-column align-items-center">
                    <div class="image-radio d-flex align-items-center justify-content-center video-playoverlay">
                      <img
                        src="https://i0.wp.com/picjumbo.com/wp-content/uploads/gorgeous-sunset-over-the-sea-free-image.jpeg?h=800&quality=80"
                        alt="Sample Image" appNgSrcImageError>
                    </div>

                    <div class="d-flex flex-column align-items-center">
                      <div
                        class="image-radio-selector d-flex align-items-center justify-content-center pt-2 ps-1 lh-1 border">
                        <app-form-radio [fG]="feedbackForm" [fCN]="'radio_options'" [value]="'optional'"
                          [cssClass]="'e-large  mb-3'"></app-form-radio>
                      </div>

                      <div class="d-flex mt-2 p-1">
                        <app-form-label
                          [label]="'This is a feedback label length test, to see how big this label can grow in different containers so.'"></app-form-label>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- If requires mandatory comment -->
                <div class="d-flex flex-column my-3">
                  <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                  <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                    [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                    [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
                </div>
              </div>
            </div>

            <!--SLIDER CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title  d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">4</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column w-100 ps-md-3">
                <div class="mt-2">
                  <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                </div>
                <div class="mt-2 mb-1 ps-2 pe-3">
                  <ejs-slider [type]="'MinRange'" [value]="initialValue" [min]="minInterval" [max]="maxInterval"
                    [ticks]="ticks" [step]="handleSteps" [tooltip]="tooltip"
                    (tooltipChange)='tooltipChangeHandler($event)'
                    (renderingTicks)='renderingTicksHandler($event)'></ejs-slider>
                </div>
                <!-- If requires mandatory comment -->
                <div class="d-flex flex-column my-3">
                  <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                  <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                    [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                    [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
                </div>
              </div>
            </div>

            <!--RATING CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">4</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column w-100 ps-md-3">
                <div class="d-flex flex-column align-items-center">
                  <div class="mt-2">
                    <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                  </div>
                  <div class="mt-2 mb-1">
                    <input ejs-rating value="0" showLabel="true" labelPosition="Top" precision="Half"
                      allowReset="true" />
                  </div>
                </div>
                <!-- If requires mandatory comment -->
                <div class="d-flex flex-column my-3">
                  <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                  <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                    [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                    [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
                </div>
              </div>
            </div>

            <!--TEXT CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">5</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column w-100 ps-md-3">
                <div class="mt-2">
                  <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                </div>
                <div class="mt-2 mb-1">
                  <app-form-textarea [placeholder]="('FEEDBACKQUESTIONTEXTPLACEHOLDER' | translate)"
                    [fCN]="'feedback_text'" [fG]="feedbackForm" [maxChars]="250" [rows]="4"></app-form-textarea>
                </div>
              </div>
            </div>

            <!--DROPDOWN CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">6</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column ps-md-3">
                <div class="mt-2">
                  <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                </div>
                <div class="mt-2 mb-1">
                  <app-form-dropdown [fG]="feedbackForm" [fCN]="'skipto_logic'" [dataSource]="skipto_logic_options"
                    [placeholder]="'SELECT' | translate" [marker]="'priority'"></app-form-dropdown>
                </div>
              </div>
              <!-- If requires mandatory comment -->
              <div class="d-flex flex-column my-3 ps-md-3 w-100">
                <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                  [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                  [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
              </div>
            </div>

            <!--REORDER CHOICE  add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings-->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">7</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column ps-md-3">
                <div class="mt-2">
                  <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                </div>
                <div class="d-flex flex-column mt-2 mb-1">
                  <div class="card mb-2">
                    <div class="d-flex align-items-stretch">
                      <div class="d-flex align-items-center justify-content-center border-end p-2">
                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                          [fontDecoration]="'fw-bold'">1.</app-content>
                      </div>
                      <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">This is a option in
                          reordarable list</app-content>
                      </div>
                      <div class="d-flex align-items-center justify-content-center border-start p-2">
                        <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'"
                          [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                        <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'"
                          [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-2">
                    <div class="d-flex align-items-stretch">
                      <div class="d-flex align-items-center justify-content-center border-end p-2">
                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                          [fontDecoration]="'fw-bold'">2.</app-content>
                      </div>
                      <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">This is a option in
                          reordarable list</app-content>
                      </div>
                      <div class="d-flex align-items-center justify-content-center border-start p-2">
                        <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'"
                          [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                        <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'"
                          [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                      </div>
                    </div>
                  </div>
                  <div class="card mb-2">
                    <div class="d-flex align-items-stretch">
                      <div class="d-flex align-items-center justify-content-center border-end p-2">
                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'"
                          [fontDecoration]="'fw-bold'">3.</app-content>
                      </div>
                      <div class="flex-grow-1 d-flex p-2 align-items-center w-100">
                        <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">This is a option in
                          reordarable list</app-content>
                      </div>
                      <div class="d-flex align-items-center justify-content-center border-start p-2">
                        <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'"
                          [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                        <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'"
                          [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- If requires mandatory comment -->
              <div class="d-flex flex-column my-3 ps-md-3 w-100">
                <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                  [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                  [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
              </div>
            </div>

            <!--DATE TIME CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">8</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column ps-md-3">
                <div class="d-flex flex-column">
                  <div class="mt-2">
                    <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                  </div>
                  <div class="mt-2 mb-1">
                    <app-form-date-time [fG]="feedbackForm" [fCN]="'datetime_answer'"
                      [disabled]="false"></app-form-date-time>
                  </div>
                </div>
              </div>
              <!-- If requires mandatory comment -->
              <div class="d-flex flex-column mt-3 ps-md-3 w-100 ">
                <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                  [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                  [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
              </div>
            </div>

            <!--DATE CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">9</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column ps-md-3">
                <div class="d-flex flex-column">
                  <div class="mt-2">
                    <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                  </div>
                  <div class="mt-2 mb-1">
                    <app-form-date [fG]="feedbackForm" [fCN]="'date_asnwer'" [disabled]="false"></app-form-date>
                  </div>
                </div>
              </div>
              <!-- If requires mandatory comment -->
              <div class="d-flex flex-column mt-3 ps-md-3 w-100 ">
                <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                  [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                  [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
              </div>
            </div>

            <!--TIME CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">10</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column ps-md-3">
                <div class="d-flex flex-column">
                  <div class="mt-2">
                    <app-form-label [label]="'This is a dynamic answer label'"></app-form-label>
                  </div>
                  <div class="mt-2 mb-1">
                    <ejs-timepicker [placeholder]="'SELECTTIME' | translate" [enabled]="true" [value]='dateValue'
                      [format]='formatString' [step]='interval' [min]='minValue' [max]='maxValue'></ejs-timepicker>
                  </div>
                </div>
              </div>
              <!-- If requires mandatory comment -->
              <div class="d-flex flex-column mt-3 ps-md-3 w-100 ">
                <app-form-label [label]="'FEEDBACKMANDATORYCOMMENTLABEL' | translate"></app-form-label>
                <app-form-textarea [placeholder]="('FEEDBACKMANDATORYCOMMENTPLACEHOLDER' | translate)"
                  [errorText]="('FEEDBACKMANDATORYCOMMENTREQUIRED' | translate)" [fCN]="'feedback_comment'"
                  [fG]="feedbackForm" [maxChars]="200" [rows]="4"></app-form-textarea>
              </div>
            </div>

            <!--FILE UPLOAD CHOICE add 'multicard-display' or 'oneform-display' or 'one-at-atime' class deppending on settings -->
            <div class="oneform-display d-flex align-items-start flex-column" [class.fade-in]="isVisibleQuestion"
              [class.fade-out]="!isVisibleQuestion">
              <div class="question-title d-flex align-items-center gap-2">
                <span class="badge rounded-pill bg-primary border text-white fs-default">11</span>
                <app-headline [type]="'h6'" [class]="'text-primary fw-bold'"
                  [title]="'How you evaluate our colaboration for this year, knowing that we changed our contract terms?'"></app-headline>
              </div>
              <!-- Description of the question -->
              <div class="question-description d-flex">
                <app-content [type]="'richtext'"
                  [innerHTML]="'Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.'"></app-content>
              </div>
              <div class="d-flex flex-wrap gap-2 uploadedFilesContainer">
                PLEASE USE THE DOCUMENT PREVIEW HERE TO DISPLAY THE ATTACHED FILES FOR EVERY QUESTION (WHERE IIT IS
                MAKING SENSE TO ALLOW QUESTION ATTACHMENTS!) FROM THE COMMENTED SOURCECODE WHICH YOU CAN FIND UNDER THIS
                TEXT
                <!--<ng-container *ngFor="let file of files; let i = index">
                    <app-item-documents-preview-selected [file]="file" [(files)]="files" [position]="i"></app-item-documents-preview-selected>
                  </ng-container>-->
              </div>
              <!-- Main Question Form Container -->
              <div class="d-flex flex-column ps-md-3 w-100">
                <div class="d-flex flex-column">
                  <div class="mt-2 mb-1">
                    <app-dialog-documents-upload [view]="'component'" [(files)]="attachmentFiles" [multiple]="true"
                      [type]="'both'"></app-dialog-documents-upload>
                  </div>
                </div>
              </div>
            </div>

            <!-- SCORE 1-->
            <div class="d-flex align-items-start flex-column my-3 w-100">
              <div class="card w-100">
                <div class="card-body">
                  <div class="d-flex justify-content-center align-items-center flex-wrap my-5 gap-2">
                    <app-headline [title]="'FEEDBACKSCORERESULT' | translate" [type]="'h5'"
                      [class]="'text-primary fw-bold'"></app-headline>
                    <app-headline [title]="'128'" [type]="'h5'" [class]="'text-primary fw-bold'"></app-headline>
                    <app-headline [title]="'FEEDBACKSCOREPREFIX' | translate" [type]="'h5'"
                      [class]="'text-primary fw-bold'"></app-headline>
                  </div>
                  <app-content [type]="'richtext'" [expandable]="false"
                    [innerHTML]="'<h5>CONGRATULATIONS!</h5></br><p>Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.</p>'"></app-content>
                </div>
              </div>
            </div>

            <!-- SCORE 2-->
            <div class="d-flex align-items-start flex-column my-3 w-100">
              <div class="card w-100">
                <div class="card-body">
                  <div class="d-flex justify-content-center align-items-center flex-wrap my-5 gap-2">
                    <app-headline [title]="'FEEDBACKSCORERESULT' | translate" [type]="'h5'"
                      [class]="'text-danger fw-bold'"></app-headline>
                    <app-headline [title]="'128'" [type]="'h5'" [class]="'text-danger fw-bold'"></app-headline>
                    <app-headline [title]="'FEEDBACKSCOREPREFIX' | translate" [type]="'h5'"
                      [class]="'text-danger fw-bold'"></app-headline>
                  </div>
                  <app-content [type]="'richtext'" [expandable]="false"
                    [innerHTML]="'<h5>WE ARE SORRY!</h5></br><p>Diese Umfrage soll dabei helfen, die Effizienz und Wirksamkeit des Managements innerhalb der Organisation zu bewerten. Ihr Feedback ist von großer Bedeutung, um Stärken zu identifizieren, Verbesserungspotenziale aufzudecken und zukünftige Entscheidungen zu unterstützen. Bitte beantworten Sie die folgenden Fragen ehrlich und auf Grundlage Ihrer persönlichen Erfahrungen. Alle Antworten werden vertraulich behandelt und ausschließlich zur Verbesserung von Prozessen, Kommunikation und Führungsqualität verwendet. Vielen Dank für Ihre Teilnahme und Ihren wertvollen Beitrag.</p>'"></app-content>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-end p-2">
          If the User sets 'Show one Question at a time' in the settings, then toggle the 'fade-in' 'fade-out' css
          classes on each choice container to fade the current question out and fade the next question in.
          <app-form-button [text]="'FEEDBACKNEXTQUESTIONBUTTON' | translate" (click)="save()" [style]="'e-btn'"
            [cssClass]="'ms-auto e-primary'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog Question Types Popup -->
    <ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='false' #showQuestionType
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'50%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKSELECTQUESTIONTYPEDIALOGTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
            [text]="('FEEDBACKSELECTIONQUESTIONTYPEHELP' | translate)" [width]="'300px'" [height]="'100px'"
            [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="d-flex flex-column p-3 custom-scrollbar h-100 overflow-y-auto">
          <div class="questionTypeTiles d-flex flex-wrap gap-3">
            <!-- SINGLE CHOICE-->
            <div [class.selected]="true"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 gap-2 w-100">
                <div class="d-flex align-items-center w-100 gap-2">
                  <div class="circle filled"></div>
                  <div class="bar"></div>
                </div>
                <div class="d-flex align-items-center w-100 gap-2">
                  <div class="circle"></div>
                  <div class="bar"></div>
                </div>
                <div class="d-flex align-items-center w-100 gap-2">
                  <div class="circle"></div>
                  <div class="bar"></div>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Einfachauswahl</div>
            </div>

            <!-- MULTIPLE CHOICE-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 gap-2 w-100">
                <div class="d-flex align-items-center w-100 gap-2">
                  <div class="square filled"></div>
                  <div class="bar"></div>
                </div>
                <div class="d-flex align-items-center w-100 gap-2">
                  <div class="square filled"></div>
                  <div class="bar"></div>
                </div>
                <div class="d-flex align-items-center w-100 gap-2">
                  <div class="square"></div>
                  <div class="bar"></div>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Mehrfachauswahl</div>
            </div>

            <!-- IMAGE CHOICE-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-3">
                  <div class="d-flex flex-column align-items-center">
                    <span class="mts-icon fs-2 text-secondary">image</span>
                    <div class="circle filled"></div>
                  </div>
                  <div class="d-flex flex-column align-items-center">
                    <span class="mts-icon fs-2 text-secondary">image</span>
                    <div class="circle"></div>
                  </div>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Bildauswahl</div>
            </div>

            <!-- SLIDER -->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="slider-track">
                  <div class="slider-thumb"></div>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Schieberegler</div>
            </div>

            <!-- STAR RATING -->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center">
                  <span class="mts-icon mts-icon-filled fs-2 text-secondary">star</span>
                  <span class="mts-icon mts-icon-filled fs-1 text-secondary">star</span>
                  <span class="mts-icon fs-2 text-secondary">star</span>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Bewertung</div>
            </div>

            <!-- CUSTOME TEXT-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-3">
                  <span class="mts-icon fs-vl lh-1 text-secondary">subject</span>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Texteingabe</div>
            </div>

            <!-- DROPDOWN-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-3">
                  <span class="mts-icon fs-vl lh-1 text-secondary">bottom_panel_close</span>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Auswahlliste</div>
            </div>

            <!-- ORDERING-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-1s">
                  <span class="mts-icon fs-2 text-secondary">arrow_upward</span>
                  <div class="d-flex flex-column gap-2">
                    <span class="mts-icon fs-3 text-secondary lh-1">looks_one</span>
                    <span class="mts-icon fs-3 text-secondary lh-1">looks_two</span>
                  </div>
                  <span class="mts-icon fs-2 text-secondary">arrow_downward</span>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Anordnen</div>
            </div>

            <!-- DATE & TIME-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-3">
                  <span class="mts-icon fs-vl lh-1 text-secondary">calendar_clock</span>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Datum und Uhrzeit</div>
            </div>

            <!--TIME-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-3">
                  <span class="mts-icon fs-vl lh-1 text-secondary">schedule</span>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Uhrzeit</div>
            </div>

            <!-- DATE-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-3">
                  <span class="mts-icon fs-vl lh-1 text-secondary">today</span>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Datum</div>
            </div>

            <!-- File-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-3">
                  <span class="mts-icon fs-vl lh-1 text-secondary">file_present</span>
                </div>
              </div>
              <div class="tile-title text-muted text-center mt-3 fs-small truncate-text-one-line">Dateien</div>
            </div>

            <!-- Score Evaluator-->
            <div [class.selected]="false"
              class="tile d-flex flex-column align-items-center justify-content-between border brd-orange text-center cursor-pointer p-3">
              <div class="d-flex flex-column align-item-start justify-content-center flex-grow-1 w-100">
                <div class="d-flex align-items-center justify-content-center gap-3">
                  <span class="mts-icon fs-vl lh-1 text-orange">network_intelligence_update</span>
                </div>
              </div>
              <div class="tile-title text-orange text-center mt-3 fs-small truncate-text-one-line">Punktebewertung</div>
            </div>

          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'FEEDBACKCREATEQUESTIONBUTTON' | translate" (click)="save()"
            [cssClass]="'e-btn e-primary mx-auto'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog For Answer Settings -->
    <ejs-dialog target=".dialogs" class="smallmenu-dialog" [visible]='false' #showAnswerSettings
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKANSWERSETTINGSTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKANSWERSETTINGSHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="custom-scrollbar overflow-y-auto h-100 mb-3 p-0">
          <div class="d-flex flex-column col-12 mx-auto justify-content-center pt-4 p-3">
            <div class="row mb-3">
              <div class="col-md-4">
                <app-form-label [label]="'FEEDBACKANSWERPOINTSLABEL' | translate"></app-form-label>
                <app-form-numeric [fG]="feedbackForm" [fCN]="'answer_points'"></app-form-numeric>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <app-form-checkbox [fCN]="'correct_answer'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'FEEDBACKCORRECTANSWERLABEL'"></app-form-checkbox>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <app-form-checkbox [fCN]="'answer_requires_comment'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'FEEDBACKREQUIRESCOMMENTLABEL'"></app-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="fakeMethod()"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog For Rating Settings -->
    <ejs-dialog target=".dialogs" class="smallmenu-dialog" [visible]='false' #showRatingSettings
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKRATINGSETTINGSTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKRATINGSETTINGSHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="custom-scrollbar overflow-y-auto h-100 mb-3 p-0">
          <div class="d-flex flex-column col-12 mx-auto justify-content-center pt-4 p-3">
            <div class="row mb-2">
              <div class="col-md-12">
                <app-form-checkbox [fCN]="'rating_showlabel'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'FEEDBACKRATINGSHOWLABEL'"></app-form-checkbox>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <app-form-checkbox [fCN]="'rating_show_reset'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'FEEDBACKRATINGSHOWRESETLABEL'"></app-form-checkbox>
              </div>
            </div>
            <div class="row mb-2">
              <div class="col-md-12">
                <app-form-checkbox [fCN]="'rating_allow_half_rates'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'FEEDBACKRATINGALLOWHALFRATESLABEL'"></app-form-checkbox>
              </div>
            </div>
            <div class="d-flex flex-row flex-wrap gap-3 mb-3">
              <div class="d-flex flex-column flex-grow-1">
                <!-- FEEDBACKSLIDERUSESLIDERVALUEASPOINTSLABEL -->
                <app-form-label [label]="'Use Rating Value as Points' | translate"></app-form-label>
                <app-form-checkbox [fCN]="'slider_use_value_as_points'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'"
                  [label]="'When enabled, the selected rating value will be used as the user’s earned points.'"></app-form-checkbox>
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">For example, if the user selects 3,
                  they will receive 3 points.</app-content>

              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="fakeMethod()"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog For Slider Settings -->
    <ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='false' #showSliderSettings
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'40%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKSLIDERSETTINGSTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKSLIDERSETTINGSHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="custom-scrollbar overflow-y-auto h-100 mb-3 p-0">
          <div class="d-flex flex-column justify-content-center pt-4 p-3">
            <div class="d-flex flex-row flex-wrap gap-3 mb-3">
              <div class="d-flex flex-column col-12 col-md-3">
                <!-- FEEDBACKSLIDERMINVALUELABEL -->
                <app-form-label [label]="'Min value' | translate"></app-form-label>
                <app-form-numeric [fG]="feedbackForm" [fCN]="'slider_minimum'" [step]="0.1"></app-form-numeric>
              </div>
              <div class="d-flex flex-column col-12 col-md-3">
                <!-- FEEDBACKSLIDERMAXVALUELABEL -->
                <app-form-label [label]="'Max value' | translate"></app-form-label>
                <app-form-numeric [fG]="feedbackForm" [fCN]="'slider_maximum'" [step]="0.1"></app-form-numeric>
              </div>
              <div class="d-flex flex-column col-12 col-md-3">
                <!-- FEEDBACKSLIDERSTEPLABEL -->
                <app-form-label [label]="'Handle steps' | translate"></app-form-label>
                <app-form-numeric [fG]="feedbackForm" [fCN]="'slider_step'" [step]="0.1"></app-form-numeric>
              </div>
            </div>
            <div class="d-flex flex-row flex-wrap gap-3 mb-3">
              <div class="d-flex flex-column flex-grow-1">
                <!-- FEEDBACKSLIDERUSESLIDERVALUEASPOINTSLABEL -->
                <app-form-label [label]="'Use Slider Value as Points' | translate"></app-form-label>
                <app-form-checkbox [fCN]="'slider_use_value_as_points'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'"
                  [label]="'When enabled, the selected slider value will be used as the user’s earned points.'"></app-form-checkbox>
                <app-content [fontSize]="'fs-default'" [fontColor]="'text-muted'">For example, if the slider range is
                  0–10 and the user selects 7, they will receive 7 points.</app-content>

              </div>
            </div>
            <div class="d-flex flex-row flex-wrap gap-3 mb-3">
              <div class="d-flex flex-column col-12 col-md-5">
                <!-- FEEDBACKSLIDERLARGESTEPMARKERLABEL -->
                <app-form-label [label]="'Large step marker' | translate"></app-form-label>
                <app-form-numeric [fG]="feedbackForm" [fCN]="'slider_label_large_step_marker'"
                  [step]="0.1"></app-form-numeric>
              </div>
              <div class="d-flex flex-column col-12 col-md-5">
                <!-- FEEDBACKSLIDERSMALLSTEPMARKERLABEL -->
                <app-form-label [label]="'Small step marker' | translate"></app-form-label>
                <app-form-numeric [fG]="feedbackForm" [fCN]="'slider_label_small_step_marker'"
                  [step]="0.1"></app-form-numeric>
              </div>
            </div>
            <div class="d-flex flex-row flex-wrap gap-3 mb-3">
              <div class="d-flex flex-column col-12 col-md-5">
                <!-- FEEDBACKSLIDERSTARTVALUELABEL -->
                <app-form-label [label]="'Handle starts at' | translate"></app-form-label>
                <app-form-numeric [fG]="feedbackForm" [fCN]="'slider_startvalue'" [step]="0.1"></app-form-numeric>
              </div>
            </div>
            <div class="d-flex flex-row flex-wrap gap-3 mb-3">
              <div class="d-flex flex-column flex-grow-1">
                <!-- FEEDBACKSLIDERSHOWSMALLSTEPSLABEL -->
                <app-form-checkbox [fCN]="'slider_show_small_steps'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'Show small steps markers'"></app-form-checkbox>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <!-- FEEDBACKSLIDERSHOWTOOLTIPONHANDLELABEL -->
                <app-form-checkbox [fCN]="'slider_show_tooltip'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'Show tooltip on handle'"></app-form-checkbox>
              </div>
            </div>

            <div class="d-flex flex-row flex-wrap align-items-center gap-3 mb-3">
              <div class="d-flex flex-column col-12 col-md-3">
                <app-form-label [label]="'Step Unit' | translate"></app-form-label>
                <app-form-input [placeholder]="('FEEDBACKSLIDERUNITPLACEHOLDER' | translate)" [fCN]="'slider_unit_text'"
                  [fG]="feedbackForm" [maxChars]="2" [hasErrorField]="false"></app-form-input>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <app-form-label [label]="'Unit by default is on the right' | translate"></app-form-label>
                <!-- FEEDBACKSLIDERTEXTONTHELEFTLABEL -->
                <app-form-checkbox [fCN]="'slider_unit_onleftside'" [fG]="feedbackForm" [cssClass]="'pb-1 lh-base'"
                  [labelPosition]="'After'" [label]="'Unit on the left side'"></app-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="fakeMethod()"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog For Dropdown Settings
    <ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='false' #showDropdownSettings [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true" (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKDROPDOWNSETTINGSTITLE' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKDROPDOWNSETTINGSHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
          <div class="d-flex flex-column h-100 p-3">
            <div class="custom-scrollbar overflow-y-auto my-3">
              <div class="card mb-2">
                <div class="d-flex align-items-stretch">
                  <div class="flex-grow-1 d-flex px-2 py-1 align-items-center">
                    <div class="w-100">
                      <app-form-input [placeholder]="('FEEDBACKDROPDOWNITEMPLACEHOLDER' | translate)" [fCN]="'feedback_dropdown_items'" [fG]="feedbackForm" [maxChars]="40" [hasErrorField]="false" [cssClass]="'flex-grow-1'"></app-form-input>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-center border-start px-2">
                    <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'" [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                    <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'" [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                  </div>
                  <div class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                    <app-form-button (click)="true" [cssClass]="'e-link text-muted p-0'" [icon]="'delete'"></app-form-button>
                  </div>
                </div>
              </div>
              <div class="my-2">
                <app-tooltip [tooltipTarget]="'.dropdownaddoption-icon'" [text]="'FEEDBACKDROPDOWNADDOPTIONTOOLTIP' | translate" [type]="'Default'" [width]="'auto'" [height]="'auto'">
                  <app-form-button [text]="'FEEDBACKDROPDOWNADDOPTION' | translate" (click)="fakeMethod()" [cssClass]="'dropdownaddoption-icon e-btn e-flat fs-6 fw-bold text-primary'" [icon]="'add'" [iconClass]="'fs-5'"></app-form-button>
                </app-tooltip>
              </div>
            </div>
          </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'FEEDBACKDROPDOWNAPPLYITEMSBUTTON' | translate" (click)="fakeMethod()" [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>-->

    <!-- Dialog For Reorderable Settings
    <ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='false' #showReorderableSettings [animationSettings]='dialogService.getAnimationSettings()' [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()' [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true" (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKREORDARABLELISTSETTINGSTITLE' | translate)" [type]="'h5'" [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKREORDARABLELISTSETTINGSHELP' | translate)" [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
          <div class="d-flex flex-column h-100 p-3">
            <div class="custom-scrollbar overflow-y-auto my-3">
              <div class="card mb-2">
                <div class="d-flex align-items-stretch">
                  <div class="d-flex align-items-center justify-content-center border-end p-2">
                    <app-content [fontSize]="'fs-default'" [fontColor]="'text-primary'" [fontDecoration]="'fw-bold'">1.</app-content>
                  </div>
                  <div class="flex-grow-1 d-flex align-items-center px-2 py-1">
                    <div class="w-100">
                      <app-form-input [placeholder]="('FEEDBACKREORDERABLEITEMPLACEHOLDER' | translate)" [fCN]="'feedback_reordarable_items'" [fG]="feedbackForm" [maxChars]="100" [hasErrorField]="false"></app-form-input>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-center border-start px-2">
                    <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'" [icon]="'keyboard_arrow_up'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                    <app-form-button [style]="'btn'" [cssClass]="'btn-link p-0 text-muted'" [icon]="'keyboard_arrow_down'" [iconClass]="'fs-5'" (click)="true"></app-form-button>
                  </div>
                  <div class="checkbox-column d-flex align-items-center justify-content-center border-start px-2">
                    <app-form-button (click)="true" [cssClass]="'e-link text-muted p-0'" [icon]="'delete'"></app-form-button>
                  </div>
                </div>
              </div>
              <div class="my-2">
                <app-tooltip [tooltipTarget]="'.dropdownaddoption-icon'" [text]="'FEEDBACKREORDERABLEITEMADDOPTIONTOOLTIP' | translate" [type]="'Default'" [width]="'auto'" [height]="'auto'">
                  <app-form-button [text]="'FEEDBACKREORDERABLEITEMADDOPTION' | translate" (click)="fakeMethod()" [cssClass]="'dropdownaddoption-icon e-btn e-flat fs-6 fw-bold text-primary'" [icon]="'add'" [iconClass]="'fs-5'"></app-form-button>
                </app-tooltip>
              </div>
            </div>
          </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'FEEDBACKREORDARABLELISTAPPLYITEMSBUTTON' | translate" (click)="fakeMethod()" [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>-->

    <!-- Dialog For Answer Time -->
    <ejs-dialog target=".dialogs" class="smallmenu-dialog" [visible]='false' #showAnswerTimeLimit
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKANSWERTIMELIMITTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKANSWERTIMELIMITHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="custom-scrollbar overflow-y-auto h-100 mb-3 p-0">
          <div class="d-flex flex-column col-12 mx-auto justify-content-center pt-4 p-3">
            <div class="row mb-3">
              <div class="col-md-12">
                <app-form-label [label]="'FEEDBACKANSWERTIMELIMITINSECONDSLABEL' | translate"></app-form-label>
                <app-form-numeric [fG]="feedbackForm" [fCN]="'answer_timelimit'"></app-form-numeric>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="fakeMethod()"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog To Manage Answer Label -->
    <ejs-dialog target=".dialogs" class="smallmenu-dialog" [visible]='false' #showManageAnswerLabel
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKMANAGEANSWERLABELTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKMANAGEANSWERLABELHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="custom-scrollbar overflow-y-auto h-100 mb-3 p-0">
          <div class="d-flex flex-column col-12 mx-auto justify-content-center pt-4 p-3">
            <div class="row mb-3">
              <div class="col-md-12">
                <app-form-label [label]="'FEEDBACKANSWERLABEL' | translate" [maxChars]="100"
                  [currentChars]="feedbackForm.controls['feedback_asnwer_label'].value.length"></app-form-label>
                <app-form-input [placeholder]="('FEEDBACKANSWERLABELPLACEHOLDER' | translate)"
                  [fCN]="'feedback_asnwer_label'" [fG]="feedbackForm" [maxChars]="100"
                  [hasErrorField]="false"></app-form-input>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="fakeMethod()"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog To Manage Question Title and Description -->
    <ejs-dialog target=".dialogs" class="simple-dialog" [visible]='false' #showManageTitleDescription
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'46vh'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKMANAGETITLEDESCRIPTIONTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'"
            [text]="('FEEDBACKMANAGETITLEDESCRIPTIONHELP' | translate)" [width]="'300px'" [height]="'100px'"
            [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="custom-scrollbar overflow-y-auto h-100 mb-3 p-0">
          <div class="d-flex flex-column col-12 mx-auto justify-content-center pt-4 p-3">
            <div class="row mb-3">
              <div class="col-md-12">
                <app-form-label [label]="'FEEDBACKQUESTIONLABEL' | translate"></app-form-label>
                <app-form-input [placeholder]="('FEEDBACKQUESTIONPLACEHOLDER' | translate)" [fCN]="'feedback_question'"
                  [fG]="feedbackForm" [maxChars]="250" [hasErrorField]="false"></app-form-input>
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-md-12">
                <app-form-label [label]="'FEEDBACKQUESTIONDESCRIPTIONLABEL' | translate"></app-form-label>
                <app-form-textarea [placeholder]="('FEEDBACKQUESTIONDESCRIPTIONPLACEHOLDER' | translate)"
                  [fCN]="'feedback_question_description'" [fG]="feedbackForm" [maxChars]="500"
                  [rows]="4"></app-form-textarea>
                <!--<app-form-textarea [placeholder]="('FEEDBACKQUESTIONDESCRIPTION' | translate)" [fCN]="'feedback_question_description'" [fG]="feedbackForm" [richText]="true" [maxChars]="500" [class]="'emojiSmall emojiOpenTop'"></app-form-textarea>-->
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="fakeMethod()"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>

    <!-- Dialog To Add Logic -->
    <ejs-dialog target=".dialogs" class="autoheight-dialog" [visible]='false' #showLogic
      [animationSettings]='dialogService.getAnimationSettings()'
      [resizeHandles]='dialogService.getResizeHandleDirection()' [position]='dialogService.getPosition()'
      [isModal]="true" [allowDragging]="false" [width]="'30%'" [height]="'auto'" [zIndex]="999" [showCloseIcon]="true"
      (close)="close()">
      <ng-template #header>
        <div class="d-flex align-items-center justify-content-center">
          <app-headline [title]="('FEEDBACKLOGICTITLE' | translate)" [type]="'h5'"
            [class]="'text-primary'"></app-headline>
          <app-tooltip [icon]="'help'" [iconClass]="'fs-5 p-1'" [text]="('FEEDBACKLOGICHELP' | translate)"
            [width]="'300px'" [height]="'100px'" [cssClass]="'helpTooltip p-2'" [opensOn]="'Click'"></app-tooltip>
        </div>
      </ng-template>
      <ng-template #content>
        <div class="d-flex flex-column justify-content-center pt-4 p-3">
          <div class="card">
            <div class="card-body p-card">
              <div class="d-flex align-items-center gap-2 mb-3">
                <span class="mts-icon text-primary fs-3">skip_next</span>
                <app-headline [title]="('FEEDBACKSKIPLOGICTITLE' | translate)" [type]="'h5'"
                  [class]="'text-primary fw-bold'"></app-headline>
              </div>


              <div class="row mb-3">
                <div class="d-flex justify-content-center mb-2">
                  <app-headline [title]="('FEEDBACKLOGICIFTITLE' | translate)" [type]="'h5'"
                    [class]="'text-primary fw-bold'"></app-headline>
                </div>
                <div class="col-12">
                  <div class="d-flex align-items-center border rounded p-2">
                    <span class="text-muted fs-6">Q1: Not satisfied</span>
                  </div>
                </div>
              </div>


              <div class="row mb-3">
                <div class="d-flex justify-content-center mb-2">
                  <app-headline [title]="('FEEDBACKLOGICISTITLE' | translate)" [type]="'h5'"
                    [class]="'text-primary fw-bold'"></app-headline>
                </div>
                <div class="col-12">
                  <app-form-dropdown [fG]="feedbackForm" [fCN]="'is_logic'" [dataSource]="is_logic_options"
                    [placeholder]="'SELECT' | translate" [marker]="'priority'"></app-form-dropdown>
                </div>
              </div>


              <div class="row mb-3">
                <div class="d-flex justify-content-center mb-2">
                  <app-headline [title]="('FEEDBACKLOGICVALUETITLE' | translate)" [type]="'h5'"
                    [class]="'text-primary fw-bold'"></app-headline>
                </div>
                <div class="col-12">
                  <app-form-input [placeholder]="('FEEDBACKLOGICVALUEPLACEHOLDER' | translate)"
                    [label]="('FEEDBACKLOGICVALUEPLACEHOLDER' | translate)" [fCN]="'feedback_logic_value'"
                    [fG]="feedbackForm" [maxChars]="60" [hasErrorField]="false"></app-form-input>
                </div>
              </div>


              <div class="row mb-3">
                <div class="d-flex justify-content-center mb-2">
                  <app-headline [title]="('FEEDBACKLOGICSKIPTOTITLE' | translate)" [type]="'h5'"
                    [class]="'text-primary fw-bold'"></app-headline>
                </div>
                <div class="col-12">
                  <app-form-dropdown [fG]="feedbackForm" [fCN]="'skipto_logic'" [dataSource]="skipto_logic_options"
                    [placeholder]="'SELECT' | translate" [marker]="'priority'"></app-form-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
      <ng-template #footerTemplate>
        <div class="d-flex align-items-center justify-content-center p-2">
          <app-form-button [text]="'SAVE' | translate" (click)="fakeMethod()"
            [cssClass]="'e-btn e-primary mx-auto w-50'"></app-form-button>
        </div>
      </ng-template>
    </ejs-dialog>
  </div>
</div>
